/* FX Sim Data - https://github.com/zhiyingzzhou/fx-sim-data */
"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  AddressInfoPanel: () => AddressInfoMockDataPanel,
  Assessment: () => Assessment,
  CompanyFinancialPanel: () => CompanyFinancialMockDataPanel,
  CompanyInfoPanel: () => CompanyMockDataPanel,
  CompanyKYC: () => CompanyKYC,
  CompanyStructurePanel: () => CompanyStructureMockDataPanel,
  CompanyUploadFilePanel: () => CompanyUploadFileMockDataPanel,
  EnhancedDueDiligencePanel: () => EnhancedDueDiligenceMockDataPanel,
  FinancialInfoPanel: () => FinancialInfoMockDataPanel,
  Panels: () => Panels,
  PersonalInfoPanel: () => PersonalInfoMockDataPanel,
  PersonalKYC: () => PersonalKYC,
  RESIDENCE_PROOF_TYPES: () => RESIDENCE_PROOF_TYPES,
  RISK_ASSESSMENT_PRESETS: () => RISK_ASSESSMENT_PRESETS,
  RiskAssessmentPanel: () => RiskAssessmentMockDataPanel,
  SupplementaryMaterialsPanel: () => SupplementaryMaterialsMockDataPanel,
  Utils: () => Utils,
  VIRTUAL_ASSET_PRESETS: () => VIRTUAL_ASSET_PRESETS,
  VirtualAssetPanel: () => VirtualAssetMockDataPanel,
  addressInfoPresets: () => addressMockDataPresets,
  calculateVirtualAssetScore: () => calculateVirtualAssetScore,
  companyFinancialPresets: () => companyFinancialPresets,
  companyInfoPresets: () => companyInfoPresets,
  companyStructurePresets: () => companyStructurePresets,
  createAddressInfo: () => generateAddressInfoMockData,
  createAddressInfoBatch: () => generateAddressInfoMockDataBatch,
  createCompanyFinancial: () => createCompanyFinancial,
  createCompanyFinancialBatch: () => createCompanyFinancialBatch,
  createCompanyInfo: () => createCompanyInfo,
  createCompanyInfoBatch: () => createCompanyInfoBatch,
  createFinancialInfo: () => generateFinancialInfoMockData,
  createFinancialInfoBatch: () => generateFinancialInfoMockDataBatch,
  createPersonalInfo: () => generatePersonalInfoMockData,
  createPersonalInfoBatch: () => generatePersonalInfoMockDataBatch,
  createRelatedPerson: () => createRelatedPerson,
  createRelatedPersonBatch: () => createRelatedPersonBatch,
  createRiskAssessment: () => createRiskAssessment,
  createVirtualAssetData: () => createVirtualAssetData,
  default: () => src_default,
  financialInfoPresets: () => financialMockDataPresets,
  getRandomRiskType: () => getRandomRiskType,
  getRandomScore: () => getRandomScore,
  personalInfoPresets: () => mockDataPresets,
  triggerAllFileUploads: () => triggerAllFileUploads,
  triggerFileUpload: () => triggerFileUpload,
  triggerFileUploadByTestId: () => triggerFileUploadByTestId,
  triggerMultipleFileUploads: () => triggerMultipleFileUploads
});
module.exports = __toCommonJS(src_exports);

// src/personal/personal-info/mockDataGenerator.personal-info.ts
var import_faker = require("@faker-js/faker");
var import_country = __toESM(require("./country-IZOX6WES.json"));
var import_country_allowed = __toESM(require("./country-allowed-7PIYYEUM.json"));
var import_country_restricted = __toESM(require("./country-restricted-BUCAVSZ3.json"));
var countryAllData = import_country.default;
var countryAllowedData = import_country_allowed.default;
var countryRestrictedData = import_country_restricted.default;
var ALL_COUNTRIES = countryAllData.data;
var ALLOWED_COUNTRIES = countryAllowedData.data;
var RESTRICTED_COUNTRIES = countryRestrictedData.data;
var NATIONALITY_CODES = {
  /** 所有国家（用于birthPlace） */
  ALL: ALL_COUNTRIES.map((c) => c.code2),
  /** 允许的国家/地区 */
  ALLOWED: ALLOWED_COUNTRIES.map((c) => c.code2),
  /** 受限制的国家/地区 */
  RESTRICTED: RESTRICTED_COUNTRIES.map((c) => c.code2),
  /** 允许和受限制国家的合集（用于nationality） */
  ALLOWED_AND_RESTRICTED: [
    ...ALLOWED_COUNTRIES.map((c) => c.code2),
    ...RESTRICTED_COUNTRIES.map((c) => c.code2)
  ]
};
var ID_TYPES = {
  /** 护照 */
  PASSPORT: "PASSPORT",
  /** 身份证（仅限香港） */
  ID_CARD: "ID_CARD",
  /** 临时身份证（海外居留） */
  TEMPORARY_ID_CARD: "TEMPORARY_ID_CARD"
};
var GENDER_OPTIONS = ["MALE", "FEMALE"];
var YES_NO_OPTIONS = ["YES", "NO"];
var CHINESE_SURNAMES = [
  "\u738B",
  "\u674E",
  "\u5F20",
  "\u5218",
  "\u9648",
  "\u6768",
  "\u9EC4",
  "\u8D75",
  "\u5468",
  "\u5434",
  "\u5F90",
  "\u5B59",
  "\u9A6C",
  "\u6731",
  "\u80E1",
  "\u90ED",
  "\u4F55",
  "\u6797",
  "\u7F57",
  "\u9AD8",
  "\u90D1",
  "\u6881",
  "\u8C22",
  "\u5B8B",
  "\u5510",
  "\u8BB8",
  "\u97E9",
  "\u51AF",
  "\u9093",
  "\u66F9"
];
var CHINESE_GIVEN_NAMES_1 = [
  "\u4F1F",
  "\u82B3",
  "\u5A1C",
  "\u79C0\u82F1",
  "\u654F",
  "\u9759",
  "\u4E3D",
  "\u5F3A",
  "\u78CA",
  "\u519B",
  "\u6D0B",
  "\u52C7",
  "\u8273",
  "\u6770",
  "\u5A1F",
  "\u6D9B",
  "\u660E",
  "\u8D85",
  "\u79C0\u5170",
  "\u971E"
];
var CHINESE_GIVEN_NAMES_2 = [
  "\u534E",
  "\u6587",
  "\u73B2",
  "\u840D",
  "\u7EA2",
  "\u5CF0",
  "\u9E4F",
  "\u8F89",
  "\u541B",
  "\u5B87",
  "\u5EFA",
  "\u56FD",
  "\u82F1",
  "\u4E91",
  "\u6CE2",
  "\u6D9B",
  "\u51EF",
  "\u6B23",
  "\u7433",
  "\u5A77"
];
function generateEnglishName(fakerInstance) {
  if (fakerInstance.number.int({ min: 1, max: 10 }) <= 8) {
    return fakerInstance.person.firstName();
  }
  const firstName = fakerInstance.person.firstName();
  const middleName = fakerInstance.person.firstName();
  return `${firstName} ${middleName}`;
}
function generateEnglishSurname(fakerInstance) {
  return fakerInstance.person.lastName();
}
function generateChineseName(fakerInstance) {
  const surname = fakerInstance.helpers.arrayElement([...CHINESE_SURNAMES]);
  if (fakerInstance.number.int({ min: 1, max: 10 }) <= 8) {
    const givenName1 = fakerInstance.helpers.arrayElement([
      ...CHINESE_GIVEN_NAMES_1
    ]);
    const givenName2 = fakerInstance.helpers.arrayElement([
      ...CHINESE_GIVEN_NAMES_2
    ]);
    return surname + givenName1 + givenName2;
  } else {
    const givenName = fakerInstance.helpers.arrayElement([
      ...CHINESE_GIVEN_NAMES_1
    ]);
    return surname + givenName;
  }
}
function generateIdNumber(fakerInstance, idType, nationality) {
  if (idType === ID_TYPES.PASSPORT) {
    const prefix2 = fakerInstance.string.alpha({
      length: fakerInstance.number.int({ min: 1, max: 2 }),
      casing: "upper"
    });
    const numbers2 = fakerInstance.string.numeric(
      fakerInstance.number.int({ min: 7, max: 9 })
    );
    return prefix2 + numbers2;
  }
  if (idType === ID_TYPES.ID_CARD && nationality === "HKG") {
    const letter = fakerInstance.string.alpha({ length: 1, casing: "upper" });
    const numbers2 = fakerInstance.string.numeric(6);
    const checkDigit = fakerInstance.helpers.arrayElement([
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A"
    ]);
    return `${letter}${numbers2}(${checkDigit})`;
  }
  const prefix = fakerInstance.string.alpha({ length: 2, casing: "upper" });
  const numbers = fakerInstance.string.numeric(8);
  return prefix + numbers;
}
function generateBirthday(fakerInstance) {
  const birthDate = fakerInstance.date.birthdate({
    min: 18,
    max: 100,
    mode: "age"
  });
  const year = birthDate.getFullYear();
  const month = String(birthDate.getMonth() + 1).padStart(2, "0");
  const day = String(birthDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
function generateExpiryDate(fakerInstance, isPermanent) {
  if (isPermanent === void 0) {
    isPermanent = fakerInstance.number.int({ min: 1, max: 10 }) <= 2;
  }
  if (isPermanent) {
    return {
      type: "permanent",
      idExpiryDate: void 0
    };
  }
  const expiryDate = fakerInstance.date.future({
    years: fakerInstance.number.int({ min: 1, max: 10 })
  });
  const year = expiryDate.getFullYear();
  const month = String(expiryDate.getMonth() + 1).padStart(2, "0");
  const day = String(expiryDate.getDate()).padStart(2, "0");
  return {
    type: "date",
    idExpiryDate: `${year}-${month}-${day}`
  };
}
function generateOverseasResidentInfo(fakerInstance, nationality) {
  const issuingCountries = NATIONALITY_CODES.ALLOWED.filter(
    (code) => code !== nationality
  );
  const idIssuingCountry = fakerInstance.helpers.arrayElement(issuingCountries);
  return {
    idIssuingCountry,
    idTypeOverseas: ID_TYPES.TEMPORARY_ID_CARD,
    idExpiryDateOverseas: generateExpiryDate(fakerInstance, false),
    // 临时证件通常不是长期有效
    idFrontOverseas: [],
    idBackOverseas: [],
    isChineseCitizen: "YES"
  };
}
function generatePersonalInfoMockData(options = {}) {
  const {
    includeOverseas = false,
    nationality: specifiedNationality,
    includeChineseName: specifiedIncludeChineseName,
    isPermanentId,
    seed
  } = options;
  const fakerInstance = seed !== void 0 ? import_faker.faker : import_faker.faker;
  if (seed !== void 0) {
    fakerInstance.seed(seed);
  }
  const nationality = specifiedNationality || fakerInstance.helpers.arrayElement(
    NATIONALITY_CODES.ALLOWED_AND_RESTRICTED
  );
  const availableIdTypes = nationality === "HKG" ? [ID_TYPES.PASSPORT, ID_TYPES.ID_CARD] : [ID_TYPES.PASSPORT];
  const idType = fakerInstance.helpers.arrayElement(availableIdTypes);
  const shouldIncludeChineseName = specifiedIncludeChineseName !== void 0 ? specifiedIncludeChineseName : ["CHN", "HKG"].includes(nationality) ? fakerInstance.number.int({ min: 1, max: 10 }) <= 8 : fakerInstance.number.int({ min: 1, max: 10 }) <= 1;
  let mockData = {
    nationality,
    idType,
    firstName: generateEnglishName(fakerInstance),
    lastName: generateEnglishSurname(fakerInstance),
    chineseName: shouldIncludeChineseName ? generateChineseName(fakerInstance) : void 0,
    idNumber: generateIdNumber(fakerInstance, idType, nationality),
    birthday: generateBirthday(fakerInstance),
    birthPlace: fakerInstance.helpers.arrayElement(NATIONALITY_CODES.ALL),
    gender: fakerInstance.helpers.arrayElement([...GENDER_OPTIONS]),
    idExpiryDate: generateExpiryDate(fakerInstance, isPermanentId),
    isSfcStaff: fakerInstance.helpers.arrayElement([...YES_NO_OPTIONS]),
    isBitcoinWorldStaff: fakerInstance.helpers.arrayElement([
      ...YES_NO_OPTIONS
    ])
  };
  if (includeOverseas) {
    mockData = {
      ...mockData,
      ...generateOverseasResidentInfo(fakerInstance, nationality)
    };
  }
  return mockData;
}
function generatePersonalInfoMockDataBatch(count, options = {}) {
  return Array.from({ length: count }, (_, index) => {
    const itemOptions = options.seed !== void 0 ? { ...options, seed: options.seed + index } : options;
    return generatePersonalInfoMockData(itemOptions);
  });
}
var mockDataPresets = {
  /**
   * 香港居民（身份证）
   */
  hkResidentWithIdCard: () => {
    const data = generatePersonalInfoMockData({
      nationality: "HKG",
      includeChineseName: true
    });
    if (data.idType !== ID_TYPES.ID_CARD) {
      data.idType = ID_TYPES.ID_CARD;
      data.idNumber = generateIdNumber(import_faker.faker, ID_TYPES.ID_CARD, "HKG");
    }
    return data;
  },
  /**
   * 中国大陆居民（护照）
   */
  mainlandChineseWithPassport: () => generatePersonalInfoMockData({
    nationality: "CHN",
    includeChineseName: true
  }),
  /**
   * 海外居住的中国公民
   */
  overseasChinese: () => generatePersonalInfoMockData({
    nationality: "CHN",
    includeChineseName: true,
    includeOverseas: true
  }),
  /**
   * 外国居民（护照）
   */
  foreignResident: () => generatePersonalInfoMockData({
    nationality: import_faker.faker.helpers.arrayElement([
      "USA",
      "GBR",
      "JPN",
      "KOR",
      "SGP"
    ]),
    includeChineseName: false
  }),
  /**
   * 长期有效证件
   */
  permanentIdDocument: () => generatePersonalInfoMockData({
    isPermanentId: true
  })
};

// src/types/enum.ts
var TradingPurposeOptions = /* @__PURE__ */ ((TradingPurposeOptions2) => {
  TradingPurposeOptions2["COMMERCIAL_TRADING"] = "COMMERCIAL_TRADING";
  TradingPurposeOptions2["SPECULATIVE_TRADING"] = "SPECULATIVE_TRADING";
  TradingPurposeOptions2["INVESTMENT_TRADING"] = "INVESTMENT_TRADING";
  TradingPurposeOptions2["DONATION_CHARITY"] = "DONATION_CHARITY";
  TradingPurposeOptions2["GOODS_SERVICES_PAYMENT"] = "GOODS_SERVICES_PAYMENT";
  TradingPurposeOptions2["CURRENCY_EXCHANGE"] = "CURRENCY_EXCHANGE";
  return TradingPurposeOptions2;
})(TradingPurposeOptions || {});
var EmploymentStatusOptions = /* @__PURE__ */ ((EmploymentStatusOptions2) => {
  EmploymentStatusOptions2["FULL_TIME_EMPLOYED"] = "FULL_TIME_EMPLOYED";
  EmploymentStatusOptions2["PART_TIME_EMPLOYED"] = "PART_TIME_EMPLOYED";
  EmploymentStatusOptions2["SELF_EMPLOYED"] = "SELF_EMPLOYED";
  EmploymentStatusOptions2["RETIRED"] = "RETIRED";
  EmploymentStatusOptions2["STUDENT"] = "STUDENT";
  EmploymentStatusOptions2["HOMEMAKER"] = "HOMEMAKER";
  EmploymentStatusOptions2["UNEMPLOYED"] = "UNEMPLOYED";
  return EmploymentStatusOptions2;
})(EmploymentStatusOptions || {});
var AddressProofTypeOptions = /* @__PURE__ */ ((AddressProofTypeOptions2) => {
  AddressProofTypeOptions2["UTILITY_BILL"] = "UTILITY_BILL";
  AddressProofTypeOptions2["FINANCIAL_STATEMENT"] = "FINANCIAL_STATEMENT";
  AddressProofTypeOptions2["TELECOM_BILL"] = "TELECOM_BILL";
  AddressProofTypeOptions2["RESIDENTIAL_LEASE"] = "RESIDENTIAL_LEASE";
  AddressProofTypeOptions2["HOTEL_APARTMENT_LEASE"] = "HOTEL_APARTMENT_LEASE";
  AddressProofTypeOptions2["SPECIAL_EMPLOYMENT_CERTIFICATE"] = "SPECIAL_EMPLOYMENT_CERTIFICATE";
  return AddressProofTypeOptions2;
})(AddressProofTypeOptions || {});
var IncomeOptions = /* @__PURE__ */ ((IncomeOptions2) => {
  IncomeOptions2["less_than_25000"] = "less_than_25000";
  IncomeOptions2["V_25000_50000"] = "25000_50000";
  IncomeOptions2["V_50000_100000"] = "50000_100000";
  IncomeOptions2["V_100000_250000"] = "100000_250000";
  IncomeOptions2["V_250000_500000"] = "250000_500000";
  IncomeOptions2["V_500000_2000000"] = "500000_2000000";
  IncomeOptions2["more_than_2000000"] = "more_than_2000000";
  return IncomeOptions2;
})(IncomeOptions || {});
var IncomeSourceOptions = /* @__PURE__ */ ((IncomeSourceOptions2) => {
  IncomeSourceOptions2["SALARY"] = "SALARY";
  IncomeSourceOptions2["INCOME_SAVINGS"] = "INCOME_SAVINGS";
  IncomeSourceOptions2["COMMISSION_BUSINESS_INCOME"] = "COMMISSION_BUSINESS_INCOME";
  IncomeSourceOptions2["PENSION_RESERVES"] = "PENSION_RESERVES";
  IncomeSourceOptions2["INVESTMENT_INCOME"] = "INVESTMENT_INCOME";
  IncomeSourceOptions2["OTHER"] = "OTHER";
  return IncomeSourceOptions2;
})(IncomeSourceOptions || {});
var IdentificationDocumentOptions = /* @__PURE__ */ ((IdentificationDocumentOptions2) => {
  IdentificationDocumentOptions2["ID_CARD"] = "ID_CARD";
  IdentificationDocumentOptions2["PASSPORT"] = "PASSPORT";
  return IdentificationDocumentOptions2;
})(IdentificationDocumentOptions || {});
var ListingStatusOptions = /* @__PURE__ */ ((ListingStatusOptions2) => {
  ListingStatusOptions2["YES"] = "YES";
  ListingStatusOptions2["NO"] = "NO";
  return ListingStatusOptions2;
})(ListingStatusOptions || {});
var CompanyKycIndividualShareholderWealthSourceOptions = /* @__PURE__ */ ((CompanyKycIndividualShareholderWealthSourceOptions2) => {
  CompanyKycIndividualShareholderWealthSourceOptions2["SALARY"] = "SALARY";
  CompanyKycIndividualShareholderWealthSourceOptions2["INCOME_SAVINGS"] = "INCOME_SAVINGS";
  CompanyKycIndividualShareholderWealthSourceOptions2["COMMISSION_BUSINESS_INCOME"] = "COMMISSION_BUSINESS_INCOME";
  CompanyKycIndividualShareholderWealthSourceOptions2["PENSION_RESERVES"] = "PENSION_RESERVES";
  CompanyKycIndividualShareholderWealthSourceOptions2["INVESTMENT_INCOME"] = "INVESTMENT_INCOME";
  CompanyKycIndividualShareholderWealthSourceOptions2["INHERITANCE_GIFT"] = "INHERITANCE_GIFT";
  CompanyKycIndividualShareholderWealthSourceOptions2["ASSET_SALE"] = "ASSET_SALE";
  CompanyKycIndividualShareholderWealthSourceOptions2["LOAN_BORROWING"] = "LOAN_BORROWING";
  CompanyKycIndividualShareholderWealthSourceOptions2["OTHER"] = "OTHER";
  return CompanyKycIndividualShareholderWealthSourceOptions2;
})(CompanyKycIndividualShareholderWealthSourceOptions || {});
var CompanyRelatedPersonTypeOptions = /* @__PURE__ */ ((CompanyRelatedPersonTypeOptions2) => {
  CompanyRelatedPersonTypeOptions2["SHAREHOLDER_BENEFICIAL_OWNER"] = "SHAREHOLDER_BENEFICIAL_OWNER";
  CompanyRelatedPersonTypeOptions2["CLIENT_REPRESENTATIVE"] = "CLIENT_REPRESENTATIVE";
  CompanyRelatedPersonTypeOptions2["AUTHORIZED_SIGNATORY"] = "AUTHORIZED_SIGNATORY";
  CompanyRelatedPersonTypeOptions2["PRINCIPAL"] = "PRINCIPAL";
  CompanyRelatedPersonTypeOptions2["DIRECTOR"] = "DIRECTOR";
  CompanyRelatedPersonTypeOptions2["TRUSTEE"] = "TRUSTEE";
  CompanyRelatedPersonTypeOptions2["OTHER_RELATED_PERSON"] = "OTHER_RELATED_PERSON";
  return CompanyRelatedPersonTypeOptions2;
})(CompanyRelatedPersonTypeOptions || {});
var CompanyTypeOptions = /* @__PURE__ */ ((CompanyTypeOptions2) => {
  CompanyTypeOptions2["NON_PROFIT"] = "NON_PROFIT";
  CompanyTypeOptions2["FOR_PROFIT"] = "FOR_PROFIT";
  CompanyTypeOptions2["GOVERNMENT"] = "GOVERNMENT";
  return CompanyTypeOptions2;
})(CompanyTypeOptions || {});
var CompanyLegalPersonShareholderWealthSourceOptions = /* @__PURE__ */ ((CompanyLegalPersonShareholderWealthSourceOptions2) => {
  CompanyLegalPersonShareholderWealthSourceOptions2["SHAREHOLDER_PARTNER_FUNDS"] = "SHAREHOLDER_PARTNER_FUNDS";
  CompanyLegalPersonShareholderWealthSourceOptions2["OPERATING_INCOME"] = "OPERATING_INCOME";
  CompanyLegalPersonShareholderWealthSourceOptions2["INVESTMENT_INCOME"] = "INVESTMENT_INCOME";
  CompanyLegalPersonShareholderWealthSourceOptions2["INVESTMENT_SALE"] = "INVESTMENT_SALE";
  CompanyLegalPersonShareholderWealthSourceOptions2["EXTERNAL_BORROWING"] = "EXTERNAL_BORROWING";
  CompanyLegalPersonShareholderWealthSourceOptions2["INTEREST_INCOME"] = "INTEREST_INCOME";
  CompanyLegalPersonShareholderWealthSourceOptions2["DIVIDEND_INCOME"] = "DIVIDEND_INCOME";
  CompanyLegalPersonShareholderWealthSourceOptions2["RENTAL_INCOME"] = "RENTAL_INCOME";
  CompanyLegalPersonShareholderWealthSourceOptions2["OTHER"] = "OTHER";
  return CompanyLegalPersonShareholderWealthSourceOptions2;
})(CompanyLegalPersonShareholderWealthSourceOptions || {});
var GenderOptions = /* @__PURE__ */ ((GenderOptions2) => {
  GenderOptions2["MALE"] = "MALE";
  GenderOptions2["FEMALE"] = "FEMALE";
  return GenderOptions2;
})(GenderOptions || {});
var YesNoOptions = /* @__PURE__ */ ((YesNoOptions2) => {
  YesNoOptions2["YES"] = "YES";
  YesNoOptions2["NO"] = "NO";
  return YesNoOptions2;
})(YesNoOptions || {});

// src/personal/address-info/mockDataGenerator.address-info.ts
var import_faker2 = require("@faker-js/faker");
var import_country_allowed2 = __toESM(require("./country-allowed-7PIYYEUM.json"));
var countryAllowedData2 = import_country_allowed2.default;
var ALLOWED_COUNTRIES2 = countryAllowedData2.data;
var COUNTRY_CODES = ALLOWED_COUNTRIES2.map((c) => c.code2);
var RESIDENCE_PROOF_TYPES = Object.values(AddressProofTypeOptions);
function generateAddressInfoMockData(options = {}) {
  const {
    currentCountry: specifiedCountry,
    residenceProofType: specifiedProofType,
    seed
  } = options;
  const fakerInstance = seed !== void 0 ? import_faker2.faker : import_faker2.faker;
  if (seed !== void 0) {
    fakerInstance.seed(seed);
  }
  const currentCountry = specifiedCountry || fakerInstance.helpers.arrayElement(COUNTRY_CODES);
  const residenceProofType = specifiedProofType || fakerInstance.helpers.arrayElement(RESIDENCE_PROOF_TYPES);
  const residenceProofFile = [];
  return {
    currentCountry,
    residenceProofType,
    residenceProofFile
  };
}
function generateAddressInfoMockDataBatch(count, options = {}) {
  return Array.from({ length: count }, (_, index) => {
    const itemOptions = options.seed !== void 0 ? { ...options, seed: options.seed + index } : options;
    return generateAddressInfoMockData(itemOptions);
  });
}
var addressMockDataPresets = {
  /**
   * 香港居民（水电煤账单）
   */
  hkResidentWithUtilityBill: () => generateAddressInfoMockData({
    currentCountry: "HKG",
    residenceProofType: "UTILITY_BILL" /* UTILITY_BILL */
  }),
  /**
   * 中国大陆居民（银行对账单）
   */
  mainlandChineseWithBankStatement: () => generateAddressInfoMockData({
    currentCountry: "CHN",
    residenceProofType: "FINANCIAL_STATEMENT" /* FINANCIAL_STATEMENT */
  }),
  /**
   * 外国居民（租赁合同）
   */
  foreignResidentWithRental: () => generateAddressInfoMockData({
    currentCountry: import_faker2.faker.helpers.arrayElement(["USA", "GBR", "JPN", "SGP"]),
    residenceProofType: "RESIDENTIAL_LEASE" /* RESIDENTIAL_LEASE */
  }),
  /**
   * 酒店公寓租赁
   */
  hotelApartmentLease: () => generateAddressInfoMockData({
    residenceProofType: "HOTEL_APARTMENT_LEASE" /* HOTEL_APARTMENT_LEASE */
  })
};

// src/personal/financial-info/mockDataGenerator.financial-info.ts
var import_faker3 = require("@faker-js/faker");
var import_country2 = __toESM(require("./country-IZOX6WES.json"));
var import_country_allowed3 = __toESM(require("./country-allowed-7PIYYEUM.json"));
var countryAllData2 = import_country2.default;
var countryAllowedData3 = import_country_allowed3.default;
var EMPLOYMENT_STATUS_OPTIONS = Object.values(EmploymentStatusOptions);
var COMMON_INDUSTRY_OPTIONS = [
  "Information and Communication Workers" /* Information_and_Communication_Workers */,
  "Financial and Insurance Workers" /* Financial_and_Insurance_Workers */,
  "Professional, Scientific, and Technical Service Workers" /* Professional_Scientific_and_Technical_Service_Workers */,
  "Education Service Workers" /* Education_Service_Workers */,
  "Health and Social Work Service Workers" /* Health_and_Social_Work_Service_Workers */,
  "Manufacturing Workers" /* Manufacturing_Workers */,
  "Wholesale and Retail Trade Workers" /* Wholesale_and_Retail_Trade_Workers */,
  "Real Estate Workers" /* Real_Estate_Workers */,
  "Self-employed" /* Self_employed */,
  "Retired" /* Retired */,
  "Unemployed" /* Unemployed */
];
var ANNUAL_INCOME_OPTIONS = Object.values(IncomeOptions);
var INCOME_SOURCE_OPTIONS = Object.values(IncomeSourceOptions);
var TRANSACTION_PURPOSE_OPTIONS = Object.values(TradingPurposeOptions);
var ALL_COUNTRIES2 = countryAllData2.data;
var ALLOWED_COUNTRIES3 = countryAllowedData3.data;
var ALL_COUNTRY_CODES = ALL_COUNTRIES2.map((c) => c.code2);
var ALLOWED_COUNTRY_CODES = ALLOWED_COUNTRIES3.map(
  (c) => c.code2
);
function generateNetWorth(fakerInstance) {
  const amount = fakerInstance.number.int({ min: 1e4, max: 1e7 });
  return String(amount);
}
function generateAssetRatio(fakerInstance) {
  const ratio = fakerInstance.number.int({ min: 0, max: 30 });
  return String(ratio);
}
function generateTIN(fakerInstance, country) {
  if (country === "HKG") {
    return fakerInstance.string.alpha({ length: 1, casing: "upper" }) + fakerInstance.string.numeric(7);
  } else if (country === "CHN") {
    return fakerInstance.string.numeric(18);
  } else {
    return fakerInstance.string.alphanumeric({ length: 10, casing: "upper" });
  }
}
function generateTaxJurisdictions(fakerInstance) {
  const count = fakerInstance.number.int({ min: 1, max: 2 });
  const selectedCountries = fakerInstance.helpers.arrayElements(
    ALL_COUNTRY_CODES,
    count
  );
  return selectedCountries.map((country) => ({
    tins_country: country,
    tins_taxId: generateTIN(fakerInstance, country)
  }));
}
function generateFinancialInfoMockData(options = {}) {
  const {
    employmentStatus: specifiedEmploymentStatus,
    industry: specifiedIndustry,
    incomeSourceCountry: specifiedCountry,
    isUSPerson: specifiedIsUSPerson = "NO",
    initialFundSameAsIncome = void 0,
    seed
  } = options;
  const fakerInstance = seed !== void 0 ? import_faker3.faker : import_faker3.faker;
  if (seed !== void 0) {
    fakerInstance.seed(seed);
  }
  const employmentStatus = specifiedEmploymentStatus || fakerInstance.helpers.arrayElement(EMPLOYMENT_STATUS_OPTIONS);
  const industry = specifiedIndustry || fakerInstance.helpers.arrayElement(COMMON_INDUSTRY_OPTIONS);
  const annualIncome = fakerInstance.helpers.arrayElement(
    ANNUAL_INCOME_OPTIONS
  );
  const incomeSourceCountry = specifiedCountry || fakerInstance.helpers.arrayElement(ALLOWED_COUNTRY_CODES);
  const incomeSourceCount = fakerInstance.number.int({ min: 1, max: 3 });
  const incomeSource = fakerInstance.helpers.arrayElements(
    INCOME_SOURCE_OPTIONS,
    incomeSourceCount
  );
  const incomeSourceRemark = incomeSource.includes("OTHER" /* OTHER */) ? fakerInstance.helpers.arrayElement([
    "\u4EB2\u53CB\u8D60\u4E88",
    "\u5BB6\u5EAD\u7EE7\u627F\u8D22\u4EA7",
    "\u6295\u8D44\u6536\u76CA",
    "\u8D44\u4EA7\u51FA\u552E\u6240\u5F97",
    "\u521B\u4E1A\u80A1\u6743\u9000\u51FA",
    "\u7248\u6743\u548C\u4E13\u5229\u6536\u5165"
  ]) : void 0;
  const sameAsIncome = initialFundSameAsIncome !== void 0 ? initialFundSameAsIncome : fakerInstance.datatype.boolean();
  const initialFundSourceSources = sameAsIncome ? [] : fakerInstance.helpers.arrayElements(
    INCOME_SOURCE_OPTIONS,
    fakerInstance.number.int({ min: 1, max: 3 })
  );
  const initialFundSource = {
    sameAsIncome,
    sources: initialFundSourceSources
  };
  const initialFundSourceRemark = initialFundSourceSources.includes(
    "OTHER" /* OTHER */
  ) ? fakerInstance.helpers.arrayElement([
    "\u5386\u5E74\u5DE5\u4F5C\u79EF\u84C4",
    "\u5BB6\u5EAD\u8D44\u4EA7\u652F\u6301",
    "\u6295\u8D44\u7406\u8D22\u6536\u76CA",
    "\u623F\u4EA7\u51FA\u552E\u6240\u5F97",
    "\u4F01\u4E1A\u7ECF\u8425\u5229\u6DA6",
    "\u80A1\u6743\u6295\u8D44\u56DE\u62A5"
  ]) : void 0;
  const transactionPurpose = fakerInstance.helpers.arrayElements(
    TRANSACTION_PURPOSE_OPTIONS,
    fakerInstance.number.int({ min: 1, max: 3 })
  );
  const netWorth = generateNetWorth(fakerInstance);
  const otherPlatformNetWorthRatio = generateAssetRatio(fakerInstance);
  const isUSPerson = specifiedIsUSPerson;
  const tins = isUSPerson === "NO" ? generateTaxJurisdictions(fakerInstance) : void 0;
  return {
    employmentStatus,
    industry,
    annualIncome,
    incomeSourceCountry,
    incomeSource,
    incomeSourceRemark,
    initialFundSource,
    initialFundSourceRemark,
    transactionPurpose,
    netWorth,
    otherPlatformNetWorthRatio,
    isUSPerson,
    tins
  };
}
function generateFinancialInfoMockDataBatch(count, options = {}) {
  return Array.from({ length: count }, (_, index) => {
    const itemOptions = options.seed !== void 0 ? { ...options, seed: options.seed + index } : options;
    return generateFinancialInfoMockData(itemOptions);
  });
}
var financialMockDataPresets = {
  /**
   * 全职在职 - 科技行业
   */
  fullTimeEmployedTech: () => generateFinancialInfoMockData({
    employmentStatus: "FULL_TIME_EMPLOYED" /* FULL_TIME_EMPLOYED */,
    industry: "Information and Communication Workers" /* Information_and_Communication_Workers */
  }),
  /**
   * 自雇人士
   */
  selfEmployed: () => generateFinancialInfoMockData({
    employmentStatus: "SELF_EMPLOYED" /* SELF_EMPLOYED */,
    industry: "Self-employed" /* Self_employed */
  }),
  /**
   * 高净值人士
   */
  highNetWorth: () => {
    const data = generateFinancialInfoMockData({});
    return {
      ...data,
      annualIncome: "more_than_2000000" /* more_than_2000000 */,
      netWorth: String(import_faker3.faker.number.int({ min: 5e6, max: 2e7 }))
    };
  },
  /**
   * 学生
   */
  student: () => generateFinancialInfoMockData({
    employmentStatus: "STUDENT" /* STUDENT */,
    industry: "Education Service Workers" /* Education_Service_Workers */
  }),
  /**
   * 退休人士
   */
  retired: () => generateFinancialInfoMockData({
    employmentStatus: "RETIRED" /* RETIRED */,
    industry: "Retired" /* Retired */
  })
};

// src/company/company-info/mockDataGenerator.company.ts
var import_faker4 = require("@faker-js/faker");
var import_country_allowed4 = __toESM(require("./country-allowed-7PIYYEUM.json"));
var import_country_restricted2 = __toESM(require("./country-restricted-BUCAVSZ3.json"));
var countryAllowedData4 = import_country_allowed4.default;
var countryRestrictedData2 = import_country_restricted2.default;
var LISTING_STATUS_OPTIONS = Object.values(ListingStatusOptions);
var COMPANY_TYPE_OPTIONS = Object.values(CompanyTypeOptions);
var COMMON_COMPANY_INDUSTRY_OPTIONS = [
  "Information and Communication" /* Information_and_Communication */,
  "Financial and Insurance Activities" /* Financial_and_Insurance_Activities */,
  "Professional, Scientific and Technical Services" /* Professional_Scientific_and_Technical_Services */,
  "Wholesale and Retail Trade" /* Wholesale_and_Retail_Trade */,
  "Manufacturing" /* Manufacturing */,
  "Real Estate Activities" /* Real_Estate_Activities */,
  "Administrative and Support Service Activities" /* Administrative_and_Support_Service_Activities */,
  "Education" /* Education */,
  "Transportation and Storage" /* Transportation_and_Storage */,
  "Construction" /* Construction */
];
var TRADING_PURPOSE_OPTIONS = Object.values(TradingPurposeOptions);
var ALLOWED_COUNTRIES4 = countryAllowedData4.data;
var RESTRICTED_COUNTRIES2 = countryRestrictedData2.data;
var ALL_AVAILABLE_COUNTRIES = [...ALLOWED_COUNTRIES4, ...RESTRICTED_COUNTRIES2];
var COUNTRY_TEL_MAP = new Map(
  ALL_AVAILABLE_COUNTRIES.map((country) => [country.code2, country.tel])
);
function generateCompanyName(fakerInstance) {
  const baseName = fakerInstance.company.name();
  let cleaned = baseName.replace(/[^a-zA-Z0-9\s]/g, " ");
  cleaned = cleaned.replace(/\s+/g, " ");
  cleaned = cleaned.trim();
  if (!cleaned || !/[a-zA-Z]/.test(cleaned)) {
    cleaned = "Company " + fakerInstance.string.numeric(5);
  }
  if (fakerInstance.number.int({ min: 1, max: 10 }) <= 3) {
    const suffixes = ["Ltd", "Limited", "Corp", "Inc", "Group"];
    cleaned = cleaned + " " + fakerInstance.helpers.arrayElement(suffixes);
  }
  if (cleaned.length > 50) {
    cleaned = cleaned.substring(0, 50).trim();
  }
  return cleaned;
}
function generateCompanyNameZh(fakerInstance) {
  const prefixes = ["\u9999\u6E2F", "\u6DF1\u5733", "\u4E0A\u6D77", "\u5317\u4EAC", "\u5E7F\u5DDE", ""];
  const types = ["\u79D1\u6280", "\u8D38\u6613", "\u91D1\u878D", "\u5B9E\u4E1A", "\u6295\u8D44", "\u54A8\u8BE2"];
  const suffixes = ["\u6709\u9650\u516C\u53F8", "\u96C6\u56E2\u6709\u9650\u516C\u53F8", "\u63A7\u80A1\u6709\u9650\u516C\u53F8"];
  const prefix = fakerInstance.helpers.arrayElement(prefixes);
  const name = fakerInstance.helpers.arrayElement([
    "\u65B0\u4E16\u7EAA",
    "\u534E\u6CF0",
    "\u6052\u5927",
    "\u4E07\u901A",
    "\u9F0E\u76DB",
    "\u535A\u8FDC",
    "\u8BDA\u4FE1",
    "\u76DB\u4E16",
    "\u9F99\u817E",
    "\u745E\u4E30",
    "\u5929\u6210",
    "\u5B8F\u56FE",
    "\u9526\u7EE3",
    "\u5609\u4FE1",
    "\u817E\u98DE",
    "\u8FDC\u4E1C"
  ]);
  const type = fakerInstance.helpers.arrayElement(types);
  const suffix = fakerInstance.helpers.arrayElement(suffixes);
  return `${prefix}${name}${type}${suffix}`;
}
function generateBankAccountName(fakerInstance) {
  const baseName = fakerInstance.company.name();
  let cleaned = baseName.replace(/[^a-zA-Z0-9\s]/g, " ");
  cleaned = cleaned.replace(/\s+/g, " ");
  cleaned = cleaned.trim();
  if (!cleaned || !/[a-zA-Z]/.test(cleaned)) {
    cleaned = "Company " + fakerInstance.string.numeric(5);
  }
  if (fakerInstance.number.int({ min: 1, max: 10 }) <= 3) {
    const suffixes = ["Ltd", "Limited", "Corp", "Inc"];
    cleaned = cleaned + " " + fakerInstance.helpers.arrayElement(suffixes);
  }
  if (cleaned.length > 50) {
    cleaned = cleaned.substring(0, 50).trim();
  }
  return cleaned;
}
function generateHKBusinessRegNo(fakerInstance) {
  const part1 = fakerInstance.string.numeric(8);
  const part2 = fakerInstance.string.numeric(3);
  return `${part1}${part2}`;
}
function generateIncorporationNo(fakerInstance, country) {
  if (country === "HKG") {
    return fakerInstance.string.numeric(7);
  } else if (country === "CHN") {
    return fakerInstance.string.alphanumeric({ length: 18, casing: "upper" });
  } else {
    return fakerInstance.string.alphanumeric({ length: 10, casing: "upper" });
  }
}
function generateAddress(fakerInstance, country) {
  if (country === "HKG") {
    const districts = [
      "Central",
      "Admiralty",
      "Wan Chai",
      "Causeway Bay",
      "Tsim Sha Tsui",
      "Mong Kok",
      "Kwun Tong",
      "Sha Tin",
      "Tuen Mun",
      "Yuen Long"
    ];
    const district = fakerInstance.helpers.arrayElement(districts);
    const building = fakerInstance.company.name() + " Tower";
    const floor = fakerInstance.number.int({ min: 1, max: 50 });
    const room = fakerInstance.number.int({ min: 1, max: 20 });
    return `Room ${room}, ${floor}/F, ${building}, ${district}, Hong Kong`;
  } else if (country === "CHN") {
    return `\u4E2D\u56FD${fakerInstance.location.city()}${fakerInstance.location.street()}${fakerInstance.number.int({ min: 1, max: 999 })}\u53F7`;
  } else {
    return fakerInstance.location.streetAddress({ useFullAddress: true });
  }
}
function generateBusinessPhone(fakerInstance, country) {
  const tel = COUNTRY_TEL_MAP.get(country) || "852";
  const phoneCountry = tel;
  const phoneNumber = fakerInstance.string.numeric(8);
  return {
    phoneCountry,
    phoneNumber
  };
}
function generateCompanyInfoMockData(options = {}) {
  const {
    registrationCountry: specifiedCountry,
    listingStatus: specifiedListingStatus,
    companyType: specifiedCompanyType,
    companyIndustry: specifiedIndustry,
    seed
  } = options;
  const fakerInstance = seed !== void 0 ? import_faker4.faker : import_faker4.faker;
  if (seed !== void 0) {
    fakerInstance.seed(seed);
  }
  const registrationCountry = specifiedCountry || fakerInstance.helpers.arrayElement(ALL_AVAILABLE_COUNTRIES).code2;
  const companyName = generateCompanyName(fakerInstance);
  const companyNameZh = generateCompanyNameZh(fakerInstance);
  const bankAccountName = generateBankAccountName(fakerInstance);
  const hkBusinessRegNo = generateHKBusinessRegNo(fakerInstance);
  const listingStatus = specifiedListingStatus || fakerInstance.helpers.arrayElement(LISTING_STATUS_OPTIONS);
  const companyType = specifiedCompanyType || fakerInstance.helpers.arrayElement(COMPANY_TYPE_OPTIONS);
  const date = fakerInstance.date.past({
    years: 20
  });
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const registrationDate = `${year}-${month}-${day}`;
  const incorporationNo = generateIncorporationNo(
    fakerInstance,
    registrationCountry
  );
  const companyIndustry = specifiedIndustry || fakerInstance.helpers.arrayElement(COMMON_COMPANY_INDUSTRY_OPTIONS);
  const registeredAddress = generateAddress(fakerInstance, registrationCountry);
  const businessAddress = fakerInstance.number.int({ min: 1, max: 10 }) <= 4 ? generateAddress(fakerInstance, registrationCountry) : void 0;
  const businessPhone = generateBusinessPhone(
    fakerInstance,
    registrationCountry
  );
  const email = fakerInstance.internet.email({
    provider: fakerInstance.helpers.arrayElement([
      "company.com",
      "business.com",
      "corp.com",
      "enterprise.com"
    ])
  }).toLowerCase();
  const website = fakerInstance.number.int({ min: 1, max: 10 }) <= 8 ? `https://www.${fakerInstance.internet.domainName()}` : void 0;
  const purposeOfTransaction = fakerInstance.helpers.arrayElements(
    TRADING_PURPOSE_OPTIONS,
    fakerInstance.number.int({ min: 1, max: 3 })
  );
  return {
    companyName,
    companyNameZh,
    bankAccountName,
    hkBusinessRegNo,
    listingStatus,
    companyType,
    registrationCountry,
    registrationDate,
    incorporationNo,
    companyIndustry,
    registeredAddress,
    businessAddress,
    businessPhone,
    email,
    website,
    purposeOfTransaction
  };
}
function generateCompanyInfoMockDataBatch(count, options = {}) {
  return Array.from({ length: count }, (_, index) => {
    const itemOptions = options.seed !== void 0 ? { ...options, seed: options.seed + index } : options;
    return generateCompanyInfoMockData(itemOptions);
  });
}
var companyMockDataPresets = {
  /**
   * 香港上市公司
   */
  hkListedCompany: () => generateCompanyInfoMockData({
    registrationCountry: "HKG",
    listingStatus: "YES" /* YES */,
    companyType: "FOR_PROFIT" /* FOR_PROFIT */
  }),
  /**
   * 香港非上市公司
   */
  hkPrivateCompany: () => generateCompanyInfoMockData({
    registrationCountry: "HKG",
    listingStatus: "NO" /* NO */,
    companyType: "FOR_PROFIT" /* FOR_PROFIT */
  }),
  /**
   * 中国大陆公司
   */
  mainlandCompany: () => generateCompanyInfoMockData({
    registrationCountry: "CHN",
    listingStatus: "NO" /* NO */,
    companyType: "FOR_PROFIT" /* FOR_PROFIT */
  }),
  /**
   * 新加坡公司
   */
  singaporeCompany: () => generateCompanyInfoMockData({
    registrationCountry: "SGP",
    listingStatus: "NO" /* NO */,
    companyType: "FOR_PROFIT" /* FOR_PROFIT */
  }),
  /**
   * 非营利组织
   */
  nonProfitOrg: () => generateCompanyInfoMockData({
    companyType: "NON_PROFIT" /* NON_PROFIT */,
    listingStatus: "NO" /* NO */
  })
};

// src/company/company-structure/mockDataGenerator.company-structure.ts
var import_faker5 = require("@faker-js/faker");
var import_country3 = __toESM(require("./country-IZOX6WES.json"));
var import_country_allowed5 = __toESM(require("./country-allowed-7PIYYEUM.json"));
var import_country_restricted3 = __toESM(require("./country-restricted-BUCAVSZ3.json"));
var countryAllData3 = import_country3.default;
var countryAllowedData5 = import_country_allowed5.default;
var countryRestrictedData3 = import_country_restricted3.default;
var ALL_COUNTRIES3 = countryAllData3.data;
var ALLOWED_AND_RESTRICTED_COUNTRIES = [
  ...countryAllowedData5.data,
  ...countryRestrictedData3.data
];
var ALL_COUNTRY_CODES2 = ALL_COUNTRIES3.map((c) => c.code2);
var ALLOWED_AND_RESTRICTED_COUNTRY_CODES = ALLOWED_AND_RESTRICTED_COUNTRIES.map((c) => c.code2);
var COUNTRY_TEL_MAP2 = new Map(
  ALL_COUNTRIES3.map((country) => [country.code2, country.tel])
);
var RELATED_PERSON_TYPE_OPTIONS = Object.values(
  CompanyRelatedPersonTypeOptions
);
var GENDER_OPTIONS2 = Object.values(GenderOptions);
var YES_NO_OPTIONS2 = Object.values(YesNoOptions);
var ID_TYPE_OPTIONS = Object.values(IdentificationDocumentOptions);
var WEALTH_SOURCE_OPTIONS = Object.values(
  CompanyKycIndividualShareholderWealthSourceOptions
);
var CORPORATE_WEALTH_SOURCE_OPTIONS = Object.values(
  CompanyLegalPersonShareholderWealthSourceOptions
);
function generateEnglishName2(fakerInstance) {
  return fakerInstance.person.firstName();
}
function generateEnglishSurname2(fakerInstance) {
  const surnames = [
    "Smith",
    "Johnson",
    "Williams",
    "Brown",
    "Jones",
    "Garcia",
    "Miller",
    "Davis",
    "Rodriguez",
    "Martinez",
    "Hernandez",
    "Lopez",
    "Gonzalez",
    "Wilson",
    "Anderson",
    "Thomas",
    "Taylor",
    "Moore",
    "Jackson",
    "Martin",
    "Lee",
    "Thompson",
    "White",
    "Harris",
    "Clark",
    "Lewis",
    "Robinson",
    "Walker",
    "Young",
    "Allen",
    "King",
    "Wright",
    "Scott",
    "Torres",
    "Hill",
    "Green",
    "Adams",
    "Baker",
    "Nelson",
    "Carter",
    "Mitchell",
    "Perez",
    "Roberts",
    "Turner",
    "Phillips",
    "Campbell",
    "Parker",
    "Evans",
    "Edwards",
    "Collins",
    "Stewart",
    "Morris",
    "Rogers"
  ];
  const baseSurname = fakerInstance.helpers.arrayElement(surnames);
  const addNumber = fakerInstance.number.int({ min: 1, max: 10 }) <= 3;
  if (addNumber) {
    const number = fakerInstance.number.int({ min: 2, max: 99 });
    const withNumber = `${baseSurname} ${number}`;
    return withNumber.length <= 50 ? withNumber : baseSurname;
  }
  return baseSurname;
}
function generateChineseName2(fakerInstance) {
  const surnames = ["\u738B", "\u674E", "\u5F20", "\u5218", "\u9648", "\u6768", "\u9EC4", "\u8D75", "\u5468", "\u5434"];
  const givenNames = [
    "\u4F1F",
    "\u82B3",
    "\u5A1C",
    "\u654F",
    "\u9759",
    "\u4E3D",
    "\u5F3A",
    "\u78CA",
    "\u519B",
    "\u6D0B"
  ];
  const surname = fakerInstance.helpers.arrayElement(surnames);
  const givenName1 = fakerInstance.helpers.arrayElement(givenNames);
  const givenName2 = fakerInstance.helpers.arrayElement(givenNames);
  return surname + givenName1 + givenName2;
}
function generatePhoneNumber(fakerInstance, country) {
  const tel = COUNTRY_TEL_MAP2.get(country) || "852";
  const phoneCountry = tel;
  const phoneNumber = fakerInstance.string.numeric(8);
  return { phoneCountry, phoneNumber };
}
function generateBirthDate(fakerInstance) {
  const birthDate = fakerInstance.date.birthdate({
    min: 18,
    max: 80,
    mode: "age"
  });
  const year = birthDate.getFullYear();
  const month = String(birthDate.getMonth() + 1).padStart(2, "0");
  const day = String(birthDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
function generateAddress2(fakerInstance, country) {
  if (country === "HKG") {
    const districts = [
      "Central",
      "Admiralty",
      "Wan Chai",
      "Causeway Bay",
      "Tsim Sha Tsui"
    ];
    const district = fakerInstance.helpers.arrayElement(districts);
    const building = fakerInstance.company.name() + " Tower";
    const floor = fakerInstance.number.int({ min: 1, max: 50 });
    const room = fakerInstance.number.int({ min: 1, max: 20 });
    return `Room ${room}, ${floor}/F, ${building}, ${district}, Hong Kong`;
  } else if (country === "CHN") {
    return `\u4E2D\u56FD${fakerInstance.location.city()}${fakerInstance.location.street()}${fakerInstance.number.int({ min: 1, max: 999 })}\u53F7`;
  } else {
    return fakerInstance.location.streetAddress({ useFullAddress: true });
  }
}
function generateIdNumber2(fakerInstance, idType, country) {
  if (idType === "PASSPORT" /* PASSPORT */) {
    const prefix = fakerInstance.string.alpha({
      length: fakerInstance.number.int({ min: 1, max: 2 }),
      casing: "upper"
    });
    const numbers = fakerInstance.string.numeric(
      fakerInstance.number.int({ min: 7, max: 9 })
    );
    return prefix + numbers;
  }
  if (idType === "ID_CARD" /* ID_CARD */ && country === "HKG") {
    const letter = fakerInstance.string.alpha({ length: 1, casing: "upper" });
    const numbers = fakerInstance.string.numeric(6);
    const checkDigit = fakerInstance.helpers.arrayElement([
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A"
    ]);
    return `${letter}${numbers}${checkDigit}`;
  }
  return fakerInstance.string.alpha({ length: 2, casing: "upper" }) + fakerInstance.string.numeric(8);
}
function generateIdExpiryDate(fakerInstance, isPermanent) {
  if (isPermanent === void 0) {
    isPermanent = fakerInstance.number.int({ min: 1, max: 10 }) <= 2;
  }
  if (isPermanent) {
    return {
      type: "permanent",
      idExpiryDate: void 0
    };
  }
  const expiryDate = fakerInstance.date.future({
    years: fakerInstance.number.int({ min: 1, max: 10 })
  });
  const year = expiryDate.getFullYear();
  const month = String(expiryDate.getMonth() + 1).padStart(2, "0");
  const day = String(expiryDate.getDate()).padStart(2, "0");
  return {
    type: "date",
    idExpiryDate: `${year}-${month}-${day}`
  };
}
function generateTIN2(fakerInstance, country) {
  if (country === "HKG") {
    return fakerInstance.string.alpha({ length: 1, casing: "upper" }) + fakerInstance.string.numeric(7);
  } else if (country === "CHN") {
    return fakerInstance.string.numeric(18);
  } else {
    return fakerInstance.string.alphanumeric({ length: 10, casing: "upper" });
  }
}
function generateTaxJurisdictions2(fakerInstance) {
  const count = fakerInstance.number.int({ min: 1, max: 2 });
  const selectedCountries = fakerInstance.helpers.arrayElements(
    ALL_COUNTRY_CODES2,
    count
  );
  return selectedCountries.map((country) => ({
    tins_country: country,
    tins_taxId: generateTIN2(fakerInstance, country)
  }));
}
function generatePosition(_fakerInstance, relatedPersonTypes) {
  const positions = {
    ["SHAREHOLDER_BENEFICIAL_OWNER" /* SHAREHOLDER_BENEFICIAL_OWNER */]: "Shareholder",
    ["DIRECTOR" /* DIRECTOR */]: "Director",
    ["AUTHORIZED_SIGNATORY" /* AUTHORIZED_SIGNATORY */]: "Authorized Signatory",
    ["CLIENT_REPRESENTATIVE" /* CLIENT_REPRESENTATIVE */]: "Client Representative",
    ["PRINCIPAL" /* PRINCIPAL */]: "Principal"
  };
  const primaryType = relatedPersonTypes[0];
  return positions[primaryType] || "Director";
}
function generatePersonalShareholderData(fakerInstance, customRelatedPersonTypes) {
  const nationality = fakerInstance.helpers.arrayElement(ALL_COUNTRY_CODES2);
  const residenceCountry = fakerInstance.helpers.arrayElement(
    ALLOWED_AND_RESTRICTED_COUNTRY_CODES
  );
  const phone = generatePhoneNumber(fakerInstance, residenceCountry);
  const relatedPersonTypes = customRelatedPersonTypes || [
    "SHAREHOLDER_BENEFICIAL_OWNER" /* SHAREHOLDER_BENEFICIAL_OWNER */
  ];
  const idIssuingCountry = fakerInstance.helpers.arrayElement(ALL_COUNTRY_CODES2);
  const idType = fakerInstance.helpers.arrayElement(ID_TYPE_OPTIONS);
  const idExpiryDate = generateIdExpiryDate(fakerInstance);
  const wealthSource = fakerInstance.helpers.arrayElements(
    WEALTH_SOURCE_OPTIONS,
    fakerInstance.number.int({ min: 1, max: 3 })
  );
  const initialWealthSourceCountry = fakerInstance.helpers.arrayElement(ALL_COUNTRY_CODES2);
  const continuousWealthSourceCountry = fakerInstance.helpers.arrayElement(ALL_COUNTRY_CODES2);
  const otherWealthSourceRemark = wealthSource.includes(
    "OTHER" /* OTHER */
  ) ? fakerInstance.helpers.arrayElement([
    "\u5386\u5E74\u7D2F\u8BA1\u76C8\u4F59\u516C\u79EF",
    "\u8D44\u672C\u516C\u79EF\u8F6C\u589E",
    "\u54C1\u724C\u6EA2\u4EF7\u6536\u76CA",
    "\u6280\u672F\u8BB8\u53EF\u8D39\u6536\u5165",
    "\u7279\u8BB8\u7ECF\u8425\u6743\u6536\u76CA",
    "\u5546\u8A89\u8BC4\u4F30\u589E\u503C"
  ]) : void 0;
  return {
    relatedPersonTypes,
    // 基本信息
    firstName: generateEnglishName2(fakerInstance),
    middleName: generateEnglishName2(fakerInstance),
    // 总是生成中间名
    lastName: generateEnglishSurname2(fakerInstance),
    chineseName: generateChineseName2(fakerInstance),
    // 总是生成中文姓名
    gender: fakerInstance.helpers.arrayElement(GENDER_OPTIONS2),
    birthDate: generateBirthDate(fakerInstance),
    phoneNumber: phone,
    nationality,
    residenceCountry,
    residentialAddress: generateAddress2(fakerInstance, residenceCountry),
    position: generatePosition(fakerInstance, relatedPersonTypes),
    // 证件信息
    idIssuingCountry,
    idType,
    idNumber: generateIdNumber2(fakerInstance, idType, idIssuingCountry),
    idValidityType: idExpiryDate,
    // 财务信息
    wealthSource,
    otherWealthSourceRemark,
    initialWealthSourceCountry,
    continuousWealthSourceCountry,
    shareholdingRatio: fakerInstance.number.int({ min: 1, max: 100 }).toString(),
    isActualController: fakerInstance.helpers.arrayElement(YES_NO_OPTIONS2),
    isFinexController: fakerInstance.helpers.arrayElement(YES_NO_OPTIONS2),
    hasRelatedAccounts: fakerInstance.helpers.arrayElement(YES_NO_OPTIONS2),
    // 纳税信息
    tins: generateTaxJurisdictions2(fakerInstance)
  };
}
function generatePersonalNonShareholderData(fakerInstance, customRelatedPersonTypes) {
  const nationality = fakerInstance.helpers.arrayElement(ALL_COUNTRY_CODES2);
  const residenceCountry = fakerInstance.helpers.arrayElement(
    ALLOWED_AND_RESTRICTED_COUNTRY_CODES
  );
  const phone = generatePhoneNumber(fakerInstance, residenceCountry);
  let selectedTypes;
  if (customRelatedPersonTypes) {
    selectedTypes = customRelatedPersonTypes;
  } else {
    const nonShareholderTypes = RELATED_PERSON_TYPE_OPTIONS.filter(
      (type) => type !== "SHAREHOLDER_BENEFICIAL_OWNER" /* SHAREHOLDER_BENEFICIAL_OWNER */
    );
    selectedTypes = fakerInstance.helpers.arrayElements(
      nonShareholderTypes,
      fakerInstance.number.int({ min: 1, max: 3 })
    );
  }
  const idIssuingCountry = fakerInstance.helpers.arrayElement(ALL_COUNTRY_CODES2);
  const idType = fakerInstance.helpers.arrayElement(ID_TYPE_OPTIONS);
  const idExpiryDate = generateIdExpiryDate(fakerInstance);
  return {
    relatedPersonTypes: selectedTypes,
    // 基本信息
    firstName: generateEnglishName2(fakerInstance),
    middleName: generateEnglishName2(fakerInstance),
    // 总是生成中间名
    lastName: generateEnglishSurname2(fakerInstance),
    chineseName: generateChineseName2(fakerInstance),
    // 总是生成中文姓名
    gender: fakerInstance.helpers.arrayElement(GENDER_OPTIONS2),
    birthDate: generateBirthDate(fakerInstance),
    phoneNumber: phone,
    nationality,
    residenceCountry,
    residentialAddress: generateAddress2(fakerInstance, residenceCountry),
    position: generatePosition(fakerInstance, selectedTypes),
    // 证件信息
    idIssuingCountry,
    idType,
    idNumber: generateIdNumber2(fakerInstance, idType, idIssuingCountry),
    idValidityType: idExpiryDate
  };
}
function generateCorporateShareholderData(fakerInstance, customRelatedPersonTypes) {
  const registrationCountry = fakerInstance.helpers.arrayElement(
    ALLOWED_AND_RESTRICTED_COUNTRY_CODES
  );
  const phone = generatePhoneNumber(fakerInstance, registrationCountry);
  const corporateCompanyRelatedPersonTypes = customRelatedPersonTypes || [
    "SHAREHOLDER_BENEFICIAL_OWNER" /* SHAREHOLDER_BENEFICIAL_OWNER */
  ];
  const corporateWealthSource = fakerInstance.helpers.arrayElements(
    CORPORATE_WEALTH_SOURCE_OPTIONS,
    fakerInstance.number.int({ min: 1, max: 3 })
  );
  const corporateInitialWealthSourceCountry = fakerInstance.helpers.arrayElement(ALL_COUNTRY_CODES2);
  const corporateContinuousWealthSourceCountry = fakerInstance.helpers.arrayElement(ALL_COUNTRY_CODES2);
  const corporateNameZh = `${fakerInstance.helpers.arrayElement(["\u9999\u6E2F", "\u6DF1\u5733", "\u4E0A\u6D77", "\u5317\u4EAC", "\u5E7F\u5DDE"])}${fakerInstance.helpers.arrayElement(["\u65B0\u4E16\u7EAA", "\u534E\u6CF0", "\u6052\u5927", "\u4E07\u901A", "\u9F0E\u76DB"])}${fakerInstance.helpers.arrayElement(["\u79D1\u6280", "\u8D38\u6613", "\u91D1\u878D", "\u5B9E\u4E1A"])}\u6709\u9650\u516C\u53F8`;
  const generateCorporateName = () => {
    const companyTypes = [
      "Corporation",
      "Limited",
      "Inc",
      "LLC",
      "Group",
      "Holdings",
      "Enterprises",
      "International",
      "Global"
    ];
    const companyPrefixes = [
      "Tech",
      "Future",
      "Digital",
      "Smart",
      "Global",
      "United",
      "Pacific",
      "Asia",
      "New",
      "Prime"
    ];
    const companyMiddles = [
      "Vision",
      "Star",
      "Power",
      "Solutions",
      "Systems",
      "Dynamics",
      "Capital",
      "Ventures",
      "Partners",
      "Industries"
    ];
    const prefix = fakerInstance.helpers.arrayElement(companyPrefixes);
    const middle = fakerInstance.helpers.maybe(
      () => fakerInstance.helpers.arrayElement(companyMiddles),
      { probability: 0.6 }
    );
    const type = fakerInstance.helpers.arrayElement(companyTypes);
    const hasNumber = fakerInstance.helpers.maybe(
      () => fakerInstance.number.int({ min: 1, max: 999 }).toString(),
      { probability: 0.3 }
    );
    let name = prefix;
    if (middle) name += ` ${middle}`;
    if (hasNumber) name += ` ${hasNumber}`;
    name += ` ${type}`;
    if (name.length > 50) {
      name = `${prefix} ${type}`;
    }
    return name;
  };
  return {
    corporateCompanyRelatedPersonTypes,
    // 基本信息
    corporateName: generateCorporateName(),
    corporateNameZh,
    // 总是生成中文公司名称
    registrationCountry,
    officeAddress: generateAddress2(fakerInstance, registrationCountry),
    corporatePhoneNumber: phone,
    // 财务信息
    corporateWealthSource,
    corporateInitialWealthSourceCountry,
    corporateContinuousWealthSourceCountry,
    corporateShareholdingRatio: fakerInstance.number.int({ min: 1, max: 100 }).toString()
  };
}
function generateRelatedPersonData(options = {}) {
  const {
    type = "INDIVIDUAL" /* INDIVIDUAL */,
    isShareholdingBeneficiary = false,
    relatedPersonTypes,
    corporateRelatedPersonTypes,
    seed
  } = options;
  const fakerInstance = seed !== void 0 ? import_faker5.faker : import_faker5.faker;
  if (seed !== void 0) {
    fakerInstance.seed(seed);
  }
  const id = `person_${Date.now()}_${fakerInstance.string.alphanumeric(6)}`;
  let data;
  if (type === "CORPORATE" /* CORPORATE */) {
    data = generateCorporateShareholderData(
      fakerInstance,
      corporateRelatedPersonTypes
    );
  } else if (isShareholdingBeneficiary || relatedPersonTypes) {
    data = generatePersonalShareholderData(fakerInstance, relatedPersonTypes);
  } else {
    data = generatePersonalNonShareholderData(
      fakerInstance,
      relatedPersonTypes
    );
  }
  return {
    id,
    type,
    isShareholdingBeneficiary,
    data
  };
}
function generateRelatedPersonsBatch(count, options = {}) {
  return Array.from({ length: count }, (_, index) => {
    const itemOptions = options.seed !== void 0 ? { ...options, seed: options.seed + index } : options;
    return generateRelatedPersonData(itemOptions);
  });
}
var companyStructurePresets = {
  /**
   * 个人股东
   */
  individualShareholder: () => generateRelatedPersonData({
    type: "INDIVIDUAL" /* INDIVIDUAL */,
    isShareholdingBeneficiary: true
  }),
  /**
   * 个人董事
   */
  individualDirector: () => generateRelatedPersonData({
    type: "INDIVIDUAL" /* INDIVIDUAL */,
    isShareholdingBeneficiary: false
  }),
  /**
   * 法人股东
   */
  corporateShareholder: () => generateRelatedPersonData({
    type: "CORPORATE" /* CORPORATE */
  }),
  /**
   * 混合类型（2个个人 + 1个法人）
   */
  mixedStructure: () => [
    companyStructurePresets.individualShareholder(),
    companyStructurePresets.individualDirector(),
    companyStructurePresets.corporateShareholder()
  ]
};

// src/company/company-financial/mockDataGenerator.company-financial.ts
var import_faker6 = require("@faker-js/faker");
var import_country4 = __toESM(require("./country-IZOX6WES.json"));
var countryAllData4 = import_country4.default;
var ALL_COUNTRIES4 = countryAllData4.data;
var ALL_COUNTRY_CODES3 = ALL_COUNTRIES4.map((c) => c.code2);
var WEALTH_SOURCE_OPTIONS2 = Object.values(
  CompanyLegalPersonShareholderWealthSourceOptions
);
function generateCompanyFinancialMockData(options = {}) {
  const {
    seed,
    netProfit: customNetProfit,
    netAssets: customNetAssets,
    vaHoldingsRatio: customVaHoldingsRatio
  } = options;
  const fakerInstance = seed !== void 0 ? import_faker6.faker : import_faker6.faker;
  if (seed !== void 0) {
    fakerInstance.seed(seed);
  }
  const netProfit = customNetProfit !== void 0 ? customNetProfit : fakerInstance.number.int({ min: -1e10, max: 1e12 });
  const netAssets = customNetAssets !== void 0 ? customNetAssets : fakerInstance.number.int({ min: 0, max: 1e12 });
  const vaHoldingsRatio = customVaHoldingsRatio !== void 0 ? customVaHoldingsRatio : fakerInstance.number.int({ min: 0, max: 100 });
  const fundSourceCountry = fakerInstance.helpers.arrayElement(ALL_COUNTRY_CODES3);
  const fundSource = fakerInstance.helpers.arrayElements(
    WEALTH_SOURCE_OPTIONS2,
    fakerInstance.number.int({ min: 1, max: 3 })
  );
  const otherFundSource = fundSource.includes(
    "OTHER" /* OTHER */
  ) ? fakerInstance.helpers.arrayElement([
    "\u6765\u81EA\u6BCD\u516C\u53F8\u7684\u6CE8\u8D44\u652F\u6301",
    "\u653F\u5E9C\u9879\u76EE\u8865\u8D34\u6B3E\u9879",
    "\u6218\u7565\u6295\u8D44\u8005\u7684\u4E13\u9879\u6295\u8D44",
    "\u503A\u5238\u878D\u8D44\u6536\u5165",
    "\u8D44\u4EA7\u91CD\u7EC4\u6240\u5F97",
    "\u77E5\u8BC6\u4EA7\u6743\u8F6C\u8BA9\u6536\u5165"
  ]) : void 0;
  const wealthSource = fakerInstance.helpers.arrayElements(
    WEALTH_SOURCE_OPTIONS2,
    fakerInstance.number.int({ min: 1, max: 3 })
  );
  const otherWealthSource = wealthSource.includes(
    "OTHER" /* OTHER */
  ) ? fakerInstance.helpers.arrayElement([
    "\u5386\u5E74\u7D2F\u8BA1\u76C8\u4F59\u516C\u79EF",
    "\u8D44\u672C\u516C\u79EF\u8F6C\u589E",
    "\u54C1\u724C\u6EA2\u4EF7\u6536\u76CA",
    "\u6280\u672F\u8BB8\u53EF\u8D39\u6536\u5165",
    "\u7279\u8BB8\u7ECF\u8425\u6743\u6536\u76CA",
    "\u5546\u8A89\u8BC4\u4F30\u589E\u503C"
  ]) : void 0;
  return {
    netProfitLastFiscalYear: netProfit.toString(),
    fundSourceCountry,
    fundSource,
    otherFundSource,
    wealthSource,
    otherWealthSource,
    netAssets: netAssets.toString(),
    vaHoldingsRatio: vaHoldingsRatio.toString()
  };
}
function generateCompanyFinancialMockDataBatch(count, options = {}) {
  return Array.from({ length: count }, (_, index) => {
    const itemOptions = options.seed !== void 0 ? { ...options, seed: options.seed + index } : options;
    return generateCompanyFinancialMockData(itemOptions);
  });
}
var companyFinancialPresets = {
  /**
   * 小型盈利企业
   */
  smallProfitable: () => generateCompanyFinancialMockData({
    netProfit: import_faker6.faker.number.int({ min: 1e5, max: 1e6 }),
    netAssets: import_faker6.faker.number.int({ min: 5e5, max: 5e6 }),
    vaHoldingsRatio: import_faker6.faker.number.int({ min: 5, max: 15 })
  }),
  /**
   * 中型盈利企业
   */
  mediumProfitable: () => generateCompanyFinancialMockData({
    netProfit: import_faker6.faker.number.int({ min: 5e6, max: 5e7 }),
    netAssets: import_faker6.faker.number.int({ min: 2e7, max: 2e8 }),
    vaHoldingsRatio: import_faker6.faker.number.int({ min: 10, max: 25 })
  }),
  /**
   * 大型盈利企业
   */
  largeProfitable: () => generateCompanyFinancialMockData({
    netProfit: import_faker6.faker.number.int({ min: 1e8, max: 1e9 }),
    netAssets: import_faker6.faker.number.int({ min: 5e8, max: 5e9 }),
    vaHoldingsRatio: import_faker6.faker.number.int({ min: 15, max: 30 })
  }),
  /**
   * 亏损企业
   */
  lossmaking: () => generateCompanyFinancialMockData({
    netProfit: import_faker6.faker.number.int({ min: -1e7, max: -1e5 }),
    netAssets: import_faker6.faker.number.int({ min: 1e6, max: 5e7 }),
    vaHoldingsRatio: import_faker6.faker.number.int({ min: 0, max: 10 })
  }),
  /**
   * 高虚拟资产占比企业（接近30%监管上限）
   */
  highVaRatio: () => generateCompanyFinancialMockData({
    netProfit: import_faker6.faker.number.int({ min: 1e6, max: 5e7 }),
    netAssets: import_faker6.faker.number.int({ min: 1e7, max: 1e8 }),
    vaHoldingsRatio: import_faker6.faker.number.int({ min: 25, max: 30 })
  }),
  /**
   * 低虚拟资产占比企业
   */
  lowVaRatio: () => generateCompanyFinancialMockData({
    netProfit: import_faker6.faker.number.int({ min: 1e6, max: 1e8 }),
    netAssets: import_faker6.faker.number.int({ min: 1e7, max: 5e8 }),
    vaHoldingsRatio: import_faker6.faker.number.int({ min: 0, max: 5 })
  }),
  /**
   * 包含其他资金来源（用于测试"其他"选项）
   */
  withOtherSources: () => {
    const data = generateCompanyFinancialMockData({
      netProfit: import_faker6.faker.number.int({ min: 5e6, max: 5e7 }),
      netAssets: import_faker6.faker.number.int({ min: 2e7, max: 2e8 }),
      vaHoldingsRatio: import_faker6.faker.number.int({ min: 10, max: 25 })
    });
    if (!data.fundSource.includes(
      "OTHER" /* OTHER */
    )) {
      data.fundSource.push(
        "OTHER" /* OTHER */
      );
      data.otherFundSource = "\u6765\u81EA\u6BCD\u516C\u53F8\u7684\u6CE8\u8D44\u652F\u6301";
    }
    if (!data.wealthSource.includes(
      "OTHER" /* OTHER */
    )) {
      data.wealthSource.push(
        "OTHER" /* OTHER */
      );
      data.otherWealthSource = "\u5386\u5E74\u7D2F\u8BA1\u76C8\u4F59\u516C\u79EF";
    }
    return data;
  }
};

// src/risk-assessment/mockDataGenerator.ts
var RISK_TYPE_WEIGHT = {
  ["IRA_RISK_CONSERVATIVE" /* IRA_RISK_CONSERVATIVE */]: 0,
  // 保守型：选择最小编号（最低风险）
  ["IRA_RISK_CAUTIOUS" /* IRA_RISK_CAUTIOUS */]: 0.25,
  // 谨慎型：选择较小编号
  ["IRA_RISK_MODERATE" /* IRA_RISK_MODERATE */]: 0.5,
  // 稳健型：选择中间编号
  ["IRA_RISK_AGGRESSIVE" /* IRA_RISK_AGGRESSIVE */]: 0.75,
  // 积极型：选择较大编号
  ["IRA_RISK_VERY_AGGRESSIVE" /* IRA_RISK_VERY_AGGRESSIVE */]: 1
  // 激进型：选择最大编号（最高风险）
};
var RISK_ASSESSMENT_PRESETS = {
  /** 保守型 */
  CONSERVATIVE: {
    riskType: "IRA_RISK_CONSERVATIVE" /* IRA_RISK_CONSERVATIVE */,
    name: "\u4FDD\u5B88\u578B",
    description: "\u98CE\u9669\u627F\u53D7\u80FD\u529B\u6700\u4F4E\uFF0C\u8FFD\u6C42\u8D44\u91D1\u5B89\u5168"
  },
  /** 谨慎型 */
  CAUTIOUS: {
    riskType: "IRA_RISK_CAUTIOUS" /* IRA_RISK_CAUTIOUS */,
    name: "\u8C28\u614E\u578B",
    description: "\u98CE\u9669\u627F\u53D7\u80FD\u529B\u8F83\u4F4E\uFF0C\u8FFD\u6C42\u7A33\u5B9A\u6536\u76CA"
  },
  /** 稳健型 */
  MODERATE: {
    riskType: "IRA_RISK_MODERATE" /* IRA_RISK_MODERATE */,
    name: "\u7A33\u5065\u578B",
    description: "\u98CE\u9669\u627F\u53D7\u80FD\u529B\u4E2D\u7B49\uFF0C\u8FFD\u6C42\u6536\u76CA\u4E0E\u98CE\u9669\u5E73\u8861"
  },
  /** 积极型 */
  AGGRESSIVE: {
    riskType: "IRA_RISK_AGGRESSIVE" /* IRA_RISK_AGGRESSIVE */,
    name: "\u79EF\u6781\u578B",
    description: "\u98CE\u9669\u627F\u53D7\u80FD\u529B\u8F83\u9AD8\uFF0C\u8FFD\u6C42\u8F83\u9AD8\u6536\u76CA"
  },
  /** 激进型 */
  VERY_AGGRESSIVE: {
    riskType: "IRA_RISK_VERY_AGGRESSIVE" /* IRA_RISK_VERY_AGGRESSIVE */,
    name: "\u6FC0\u8FDB\u578B",
    description: "\u98CE\u9669\u627F\u53D7\u80FD\u529B\u6700\u9AD8\uFF0C\u8FFD\u6C42\u9AD8\u6536\u76CA"
  }
};
function generateRiskAssessmentMockData(quizData, config) {
  const { targetRiskType } = config;
  const questions = quizData.questions;
  if (!questions || questions.length === 0) {
    return {};
  }
  const weight = RISK_TYPE_WEIGHT[targetRiskType];
  const formData = {};
  questions.forEach((question) => {
    const fieldName = `question_${question["no."]}`;
    const selectedOption = selectOptionByWeight(question, weight);
    formData[fieldName] = selectedOption["no."];
  });
  return formData;
}
function selectOptionByWeight(question, weight) {
  const { options } = question;
  if (!options || options.length === 0) {
    throw new Error(`Question ${question["no."]} has no options`);
  }
  const sortedOptions = [...options].sort((a, b) => a["no."] - b["no."]);
  const index = Math.floor(weight * (sortedOptions.length - 1));
  return sortedOptions[index];
}
function generateRandomRiskType() {
  const riskTypes = [
    "IRA_RISK_CONSERVATIVE" /* IRA_RISK_CONSERVATIVE */,
    "IRA_RISK_CAUTIOUS" /* IRA_RISK_CAUTIOUS */,
    "IRA_RISK_MODERATE" /* IRA_RISK_MODERATE */,
    "IRA_RISK_AGGRESSIVE" /* IRA_RISK_AGGRESSIVE */,
    "IRA_RISK_VERY_AGGRESSIVE" /* IRA_RISK_VERY_AGGRESSIVE */
  ];
  const randomIndex = Math.floor(Math.random() * riskTypes.length);
  return riskTypes[randomIndex];
}

// src/virtual-asset-test/mockDataGenerator.ts
var VIRTUAL_ASSET_PRESETS = {
  /** 不及格 - 30分 */
  FAIL_LOW: {
    targetScore: 30,
    name: "\u4E0D\u53CA\u683C\uFF0830\u5206\uFF09",
    description: "\u7B54\u5BF93\u9053\u9898\uFF0C\u672A\u901A\u8FC7\u6D4B\u8BD5"
  },
  /** 不及格 - 60分 */
  FAIL_HIGH: {
    targetScore: 60,
    name: "\u4E0D\u53CA\u683C\uFF0860\u5206\uFF09",
    description: "\u7B54\u5BF96\u9053\u9898\uFF0C\u63A5\u8FD1\u53CA\u683C\u7EBF"
  },
  /** 刚好及格 - 70分 */
  PASS: {
    targetScore: 70,
    name: "\u53CA\u683C\uFF0870\u5206\uFF09",
    description: "\u7B54\u5BF97\u9053\u9898\uFF0C\u521A\u597D\u901A\u8FC7"
  },
  /** 良好 - 80分 */
  GOOD: {
    targetScore: 80,
    name: "\u826F\u597D\uFF0880\u5206\uFF09",
    description: "\u7B54\u5BF98\u9053\u9898\uFF0C\u8868\u73B0\u826F\u597D"
  },
  /** 优秀 - 100分 */
  EXCELLENT: {
    targetScore: 100,
    name: "\u4F18\u79C0\uFF08100\u5206\uFF09",
    description: "\u5168\u90E8\u7B54\u5BF9\uFF0C\u5B8C\u7F8E\u901A\u8FC7"
  }
};
function generateVirtualAssetMockData(questions, config) {
  const { targetScore } = config;
  if (!questions || questions.length === 0) {
    return {};
  }
  const validTargetScore = Math.max(0, Math.min(100, targetScore));
  const targetCorrectCount = Math.floor(validTargetScore / 10);
  const formData = {};
  questions.forEach((question, index) => {
    const fieldName = `question_${question["no."]}`;
    if (index < targetCorrectCount) {
      const correctOption = question.options.reduce(
        (max, current) => current.answer > max.answer ? current : max
      );
      formData[fieldName] = correctOption["no."];
    } else {
      const wrongOption = question.options.reduce(
        (min, current) => current.answer < min.answer ? current : min
      );
      formData[fieldName] = wrongOption["no."];
    }
  });
  return formData;
}
function calculateVirtualAssetScore(questions, formValues) {
  let totalScore = 0;
  questions.forEach((question) => {
    const fieldName = `question_${question["no."]}`;
    const selectedOptionNo = formValues[fieldName];
    if (selectedOptionNo !== void 0) {
      const selectedOption = question.options.find(
        (opt) => opt["no."] === selectedOptionNo
      );
      if (selectedOption) {
        totalScore += selectedOption.answer;
      }
    }
  });
  return totalScore;
}
function generateRandomScore() {
  const correctCount = Math.floor(Math.random() * 11);
  return correctCount * 10;
}

// src/utils/index.ts
var delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
var triggerReactInputChange = (inputElement, newValue) => {
  const lastValue = inputElement.value;
  inputElement.value = newValue;
  const tracker = inputElement._valueTracker;
  if (tracker) {
    tracker.setValue(lastValue);
  }
  const event = new Event("input", { bubbles: true });
  inputElement.dispatchEvent(event);
};

// src/utils/mockFileUploadTrigger.ts
async function triggerFileUpload(options = {}) {
  const {
    fileUrl = "/icon.png",
    fileName = "mock-file.png",
    selector = 'input[type="file"]',
    onSuccess,
    onError
  } = options;
  try {
    const fileInput = document.querySelector(selector);
    if (!fileInput) {
      const error = new Error("\u672A\u627E\u5230\u6587\u4EF6\u4E0A\u4F20\u63A7\u4EF6");
      onError?.(error);
      console.error("\u274C \u672A\u627E\u5230\u6587\u4EF6\u4E0A\u4F20\u63A7\u4EF6\uFF0Cselector:", selector);
      return false;
    }
    const response = await fetch(fileUrl);
    if (!response.ok) {
      throw new Error(`\u83B7\u53D6\u6587\u4EF6\u5931\u8D25: ${response.statusText}`);
    }
    const blob = await response.blob();
    const file = new File([blob], fileName, { type: blob.type });
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    fileInput.files = dataTransfer.files;
    const inputEvent = new Event("input", { bubbles: true });
    fileInput.dispatchEvent(inputEvent);
    const changeEvent = new Event("change", { bubbles: true });
    fileInput.dispatchEvent(changeEvent);
    const nativeEvent = new Event("change", { bubbles: true });
    Object.defineProperty(nativeEvent, "target", {
      writable: false,
      value: fileInput
    });
    const reactProps = Object.keys(fileInput).find(
      (key) => key.startsWith("__reactProps")
    );
    if (reactProps && fileInput[reactProps]?.onChange) {
      fileInput[reactProps].onChange({
        target: fileInput,
        currentTarget: fileInput
      });
    }
    console.log("\u2705 \u5DF2\u89E6\u53D1\u6587\u4EF6\u4E0A\u4F20:", file);
    onSuccess?.(file);
    return true;
  } catch (error) {
    const err = error instanceof Error ? error : new Error(String(error));
    onError?.(err);
    console.error("\u274C \u89E6\u53D1\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25:", error);
    return false;
  }
}
async function triggerMultipleFileUploads(selectors, options = {}) {
  let successCount = 0;
  for (const selector of selectors) {
    const success = await triggerFileUpload({
      ...options,
      selector
    });
    if (success) {
      successCount++;
      await delay(100);
    }
  }
  return successCount;
}
async function triggerFileUploadByTestId(testId, options = {}) {
  return triggerFileUpload({
    ...options,
    selector: `input[type="file"][data-testid="${testId}"]`
  });
}
async function triggerAllFileUploads(options = {}) {
  const fileInputs = document.querySelectorAll(
    'input[type="file"]'
  );
  let successCount = 0;
  for (let i = 0; i < fileInputs.length; i++) {
    const uniqueSelector = `input[type="file"]:nth-of-type(${i + 1})`;
    const success = await triggerFileUpload({
      ...options,
      selector: uniqueSelector
    });
    if (success) {
      successCount++;
      await delay(100);
    }
  }
  return successCount;
}

// src/personal/personal-info/mockDataGenerator.demo.tsx
var import_antd = require("antd");
var import_react = require("react");
var import_country5 = __toESM(require("./country-IZOX6WES.json"));
var import_jsx_runtime = require("react/jsx-runtime");
function PersonalInfoMockDataPanel({
  form
}) {
  const [visible, setVisible] = (0, import_react.useState)(false);
  if (!form) {
    return null;
  }
  const idFrontOverseas = import_antd.Form.useWatch("idFrontOverseas", form);
  (0, import_react.useEffect)(() => {
    if (idFrontOverseas && idFrontOverseas.length > 0) {
      (async () => {
        await delay(200);
        console.log("\u5DF2\u8BBE\u7F6E\u6B63\u9762\u8BC1\u4EF6\u7167\uFF0C\u8BBE\u7F6E\u80CC\u9762\u8BC1\u4EF6\u7167");
        form.setFieldValue("idBackOverseas", idFrontOverseas);
      })();
    }
  }, [idFrontOverseas, form]);
  const handleTriggerFileUpload = async () => {
    import_antd.message.loading({
      content: "\u6B63\u5728\u51C6\u5907\u6587\u4EF6...",
      key: "upload",
      duration: 0
    });
    const success = await triggerFileUpload({
      fileUrl: "/icon.png",
      fileName: "id-frontend-overseas.png",
      onSuccess: (file) => {
        import_antd.message.success({
          content: "\u2705 \u5DF2\u89E6\u53D1\u6587\u4EF6\u4E0A\u4F20",
          key: "upload",
          duration: 2
        });
        console.log("\u2705 \u5DF2\u89E6\u53D1\u6587\u4EF6\u4E0A\u4F20:", file);
      },
      onError: (error) => {
        import_antd.message.error({
          content: "\u274C \u89E6\u53D1\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25",
          key: "upload",
          duration: 2
        });
        console.error("\u274C \u89E6\u53D1\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25:", error);
      }
    });
    if (!success) {
      import_antd.message.error({
        content: "\u274C \u89E6\u53D1\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25",
        key: "upload",
        duration: 2
      });
    }
  };
  const handleTriggerSelectNationality = async (data, message7) => {
    const selectButton = document.querySelector(
      'button[aria-label="\u8BF7\u9009\u62E9\u56FD\u7C4D/\u516C\u6C11\u6743"]'
    );
    if (selectButton) {
      console.log("\u{1F527} \u6A21\u62DF\u70B9\u51FB\u9009\u62E9\u56FD\u7C4D/\u516C\u6C11\u6743");
      selectButton.click();
    }
    await delay(300);
    const searchInput = document.querySelector(
      ".generic-selector-modal-search input"
    );
    if (searchInput) {
      triggerReactInputChange(
        searchInput,
        data.nationality
      );
      await delay(200);
      const selectNationality = import_country5.default.data.find(
        (country) => country.code2 === data.nationality
      );
      const nationalityElement = document.querySelector(
        `div[role="button"]#${selectNationality?.code2}-${selectNationality?.tel}`
      );
      if (nationalityElement) {
        console.log(`\u{1F527} \u6A21\u62DF\u70B9\u51FB\u9009\u62E9${nationalityElement}`);
        nationalityElement.click();
      }
      await delay(200);
      form.setFieldsValue(data);
      console.log(`\u2705 ${message7}:`, data);
      await delay(200);
      if (message7 === "\u5DF2\u586B\u5145\u6D77\u5916\u5C45\u4F4F\u4E2D\u56FD\u516C\u6C11") {
        handleTriggerFileUpload();
      }
    }
  };
  const handleFillHkResident = () => {
    const data = mockDataPresets.hkResidentWithIdCard();
    handleTriggerSelectNationality(data, "\u5DF2\u586B\u5145\u9999\u6E2F\u5C45\u6C11\uFF08\u8EAB\u4EFD\u8BC1\uFF09");
  };
  const handleFillOverseasChinese = () => {
    const data = mockDataPresets.overseasChinese();
    handleTriggerSelectNationality(data, "\u5DF2\u586B\u5145\u6D77\u5916\u5C45\u4F4F\u4E2D\u56FD\u516C\u6C11");
  };
  const handleFillForeignResident = () => {
    const data = mockDataPresets.foreignResident();
    handleTriggerSelectNationality(data, "\u5DF2\u586B\u5145\u5916\u56FD\u5C45\u6C11\uFF08\u62A4\u7167\uFF09");
  };
  const handleFillPermanentId = () => {
    const data = mockDataPresets.permanentIdDocument();
    handleTriggerSelectNationality(data, "\u5DF2\u586B\u5145\u957F\u671F\u6709\u6548\u8BC1\u4EF6");
  };
  const handleFillRandom = () => {
    const data = generatePersonalInfoMockData();
    handleTriggerSelectNationality(data, "\u5DF2\u586B\u5145\u968F\u673A\u4E2A\u4EBA\u6570\u636E");
  };
  const handleClear = () => {
    form.resetFields();
    console.log("\u2705 \u5DF2\u6E05\u7A7A\u4E2A\u4EBA\u4FE1\u606F\u8868\u5355");
  };
  const handleToggle = () => {
    setVisible(!visible);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [
    !visible && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] group cursor-pointer",
        onClick: handleToggle,
        style: {
          width: "64px",
          height: "64px"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full transition-all duration-300 group-hover:scale-110",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 10px 25px -5px rgba(102, 126, 234, 0.5), 0 8px 10px -6px rgba(102, 126, 234, 0.3)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300",
              style: {
                background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                boxShadow: "0 15px 35px -5px rgba(118, 75, 162, 0.6)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "relative w-full h-full flex items-center justify-center text-3xl transition-transform duration-300 group-hover:scale-110 group-active:scale-95", children: "\u{1F464}" }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full animate-ping opacity-20",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                animationDuration: "3s"
              }
            }
          )
        ]
      }
    ),
    visible && /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] bg-white rounded-lg shadow-2xl",
        style: {
          width: "320px",
          maxHeight: "600px",
          display: "flex",
          flexDirection: "column",
          border: "1px solid #d9d9d9"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
            "div",
            {
              className: "flex items-center justify-between px-4 py-3",
              style: {
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
                borderRadius: "8px 8px 0 0"
              },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { className: "font-semibold text-base", children: "\u{1F464} \u4E2A\u4EBA\u4FE1\u606F Mock\u5DE5\u5177" }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_antd.Button, { size: "small", onClick: handleToggle, children: "\u2715" })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(
            "div",
            {
              className: "overflow-y-auto p-4 space-y-4",
              style: { maxHeight: "500px" },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u9884\u8BBE\u573A\u666F" }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_antd.Button, { size: "small", block: true, onClick: handleFillHkResident, children: "\u9999\u6E2F\u5C45\u6C11\uFF08\u8EAB\u4EFD\u8BC1\uFF09" }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_antd.Button, { size: "small", block: true, onClick: handleFillOverseasChinese, children: "\u6D77\u5916\u5C45\u4F4F\u4E2D\u56FD\u516C\u6C11" }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_antd.Button, { size: "small", block: true, onClick: handleFillForeignResident, children: "\u5916\u56FD\u5C45\u6C11\uFF08\u62A4\u7167\uFF09" }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_antd.Button, { size: "small", block: true, onClick: handleFillPermanentId, children: "\u957F\u671F\u6709\u6548\u8BC1\u4EF6" })
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u5176\u4ED6\u64CD\u4F5C" }),
                  /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_antd.Button, { size: "small", block: true, onClick: handleFillRandom, children: "\u968F\u673A\u751F\u6210" })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", { className: "px-4 pb-4 pt-2 border-t", children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_antd.Button, { danger: true, size: "small", block: true, onClick: handleClear, children: "\u6E05\u7A7A\u8868\u5355" }) })
        ]
      }
    )
  ] });
}

// src/personal/address-info/mockDataGenerator.demo.tsx
var import_antd2 = require("antd");
var import_react2 = require("react");
var import_jsx_runtime2 = require("react/jsx-runtime");
function AddressInfoMockDataPanel({
  form
}) {
  const [visible, setVisible] = (0, import_react2.useState)(false);
  if (!form) {
    return null;
  }
  const handleFillHkUtilityBill = () => handleFillWithFileUpload(
    addressMockDataPresets.hkResidentWithUtilityBill,
    "\u2705 \u5DF2\u586B\u5145\u9999\u6E2F\u5C45\u6C11\uFF08\u6C34\u7535\u5355\uFF09+\u4E0A\u4F20\u6587\u4EF6:"
  );
  const handleFillMainlandBankStatement = () => handleFillWithFileUpload(
    addressMockDataPresets.mainlandChineseWithBankStatement,
    "\u2705 \u5DF2\u586B\u5145\u4E2D\u56FD\u5927\u9646\u5C45\u6C11\uFF08\u94F6\u884C\u5BF9\u8D26\u5355\uFF09+\u4E0A\u4F20\u6587\u4EF6:"
  );
  const handleFillForeignRental = () => handleFillWithFileUpload(
    addressMockDataPresets.foreignResidentWithRental,
    "\u2705 \u5DF2\u586B\u5145\u5916\u56FD\u5C45\u6C11\uFF08\u79DF\u8D41\u5408\u540C\uFF09+\u4E0A\u4F20\u6587\u4EF6:"
  );
  const handleFillHotelLease = () => handleFillWithFileUpload(
    addressMockDataPresets.hotelApartmentLease,
    "\u2705 \u5DF2\u586B\u5145\u9152\u5E97\u516C\u5BD3\u79DF\u8D41+\u4E0A\u4F20\u6587\u4EF6:"
  );
  const handleFillRandom = () => handleFillWithFileUpload(
    generateAddressInfoMockData,
    "\u2705 \u5DF2\u586B\u5145\u968F\u673A\u5730\u5740\u6570\u636E+\u4E0A\u4F20\u6587\u4EF6:"
  );
  const handleClear = () => {
    form.resetFields();
    console.log("\u2705 \u5DF2\u6E05\u7A7A\u5730\u5740\u4FE1\u606F\u8868\u5355");
  };
  const handleTriggerFileUpload = async () => {
    import_antd2.message.loading({
      content: "\u6B63\u5728\u51C6\u5907\u6587\u4EF6...",
      key: "upload",
      duration: 0
    });
    const success = await triggerFileUpload({
      fileUrl: "/icon.png",
      fileName: "address-proof.png",
      onSuccess: (file) => {
        import_antd2.message.success({
          content: "\u2705 \u5DF2\u89E6\u53D1\u6587\u4EF6\u4E0A\u4F20",
          key: "upload",
          duration: 2
        });
        console.log("\u2705 \u5DF2\u89E6\u53D1\u6587\u4EF6\u4E0A\u4F20:", file);
      },
      onError: (error) => {
        import_antd2.message.error({
          content: "\u274C \u89E6\u53D1\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25",
          key: "upload",
          duration: 2
        });
        console.error("\u274C \u89E6\u53D1\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25:", error);
      }
    });
    if (!success) {
      import_antd2.message.error({
        content: "\u274C \u89E6\u53D1\u6587\u4EF6\u4E0A\u4F20\u5931\u8D25",
        key: "upload",
        duration: 2
      });
    }
  };
  const handleFillWithFileUpload = async (dataGenerator, logMessage) => {
    const data = dataGenerator();
    form.setFieldsValue(data);
    console.log(logMessage, data);
    await delay(100);
    await handleTriggerFileUpload();
  };
  const handleToggle = () => {
    setVisible(!visible);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(import_jsx_runtime2.Fragment, { children: [
    !visible && /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] group cursor-pointer",
        onClick: handleToggle,
        style: {
          width: "64px",
          height: "64px"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full transition-all duration-300 group-hover:scale-110",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 10px 25px -5px rgba(102, 126, 234, 0.5), 0 8px 10px -6px rgba(102, 126, 234, 0.3)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300",
              style: {
                background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                boxShadow: "0 15px 35px -5px rgba(118, 75, 162, 0.6)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("div", { className: "relative w-full h-full flex items-center justify-center text-3xl transition-transform duration-300 group-hover:scale-110 group-active:scale-95", children: "\u{1F3E0}" }),
          /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full animate-ping opacity-20",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                animationDuration: "3s"
              }
            }
          )
        ]
      }
    ),
    visible && /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] bg-white rounded-lg shadow-2xl",
        style: {
          width: "320px",
          maxHeight: "600px",
          display: "flex",
          flexDirection: "column",
          border: "1px solid #d9d9d9"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
            "div",
            {
              className: "flex items-center justify-between px-4 py-3",
              style: {
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
                borderRadius: "8px 8px 0 0"
              },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("span", { className: "font-semibold text-base", children: "\u{1F3E0} \u5730\u5740\u4FE1\u606F Mock\u5DE5\u5177" }),
                /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_antd2.Button, { size: "small", onClick: handleToggle, children: "\u2715" })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
            "div",
            {
              className: "overflow-y-auto p-4 space-y-4",
              style: { maxHeight: "500px" },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u9884\u8BBE\u573A\u666F" }),
                  /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_antd2.Button, { size: "small", block: true, onClick: handleFillHkUtilityBill, children: "\u9999\u6E2F\u5C45\u6C11\uFF08\u6C34\u7535\u5355\uFF09" }),
                  /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
                    import_antd2.Button,
                    {
                      size: "small",
                      block: true,
                      onClick: handleFillMainlandBankStatement,
                      children: "\u5927\u9646\u5C45\u6C11\uFF08\u94F6\u884C\u5BF9\u8D26\u5355\uFF09"
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_antd2.Button, { size: "small", block: true, onClick: handleFillForeignRental, children: "\u5916\u56FD\u5C45\u6C11\uFF08\u79DF\u8D41\u5408\u540C\uFF09" }),
                  /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_antd2.Button, { size: "small", block: true, onClick: handleFillHotelLease, children: "\u9152\u5E97\u516C\u5BD3\u79DF\u8D41" })
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u5176\u4ED6\u64CD\u4F5C" }),
                  /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_antd2.Button, { size: "small", block: true, onClick: handleFillRandom, children: "\u968F\u673A\u751F\u6210" })
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u{1F4CE} \u6587\u4EF6\u4E0A\u4F20" }),
                  /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
                    import_antd2.Button,
                    {
                      size: "small",
                      block: true,
                      type: "primary",
                      onClick: handleTriggerFileUpload,
                      children: "\u89E6\u53D1\u4E0A\u4F20\u63A7\u4EF6"
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
                    import_antd2.Button,
                    {
                      size: "small",
                      block: true,
                      type: "primary",
                      onClick: () => handleFillWithFileUpload(
                        addressMockDataPresets.hkResidentWithUtilityBill,
                        "\u2705 \u5DF2\u586B\u5145\u9999\u6E2F\u5C45\u6C11\uFF08\u6C34\u7535\u5355\uFF09+\u89E6\u53D1\u4E0A\u4F20:"
                      ),
                      children: "\u9999\u6E2F\u5C45\u6C11 + \u4E0A\u4F20"
                    }
                  )
                ] })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("div", { className: "px-4 pb-4 pt-2 border-t", children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_antd2.Button, { danger: true, size: "small", block: true, onClick: handleClear, children: "\u6E05\u7A7A\u8868\u5355" }) })
        ]
      }
    )
  ] });
}

// src/personal/financial-info/mockDataGenerator.demo.tsx
var import_antd3 = require("antd");
var import_react3 = require("react");
var import_jsx_runtime3 = require("react/jsx-runtime");
function FinancialInfoMockDataPanel({
  form
}) {
  const [visible, setVisible] = (0, import_react3.useState)(false);
  if (!form) {
    return null;
  }
  const fillFormData = async (data, logMessage) => {
    console.log(
      "\u{1F527} \u5F00\u59CB\u586B\u5145\u6570\u636E\uFF0CisUSPerson:",
      data.isUSPerson,
      "tins:",
      data.tins
    );
    form.resetFields(["isUSPerson", "tins"]);
    await delay(200);
    const noRadio = document.querySelector(
      'input[type="radio"][value="NO"]'
    );
    if (noRadio && !noRadio.checked) {
      console.log('\u{1F527} \u6A21\u62DF\u70B9\u51FB"\u5426"\u5355\u9009\u6846');
      noRadio.click();
    }
    await delay(200);
    console.log("\u{1F527} \u8BBE\u7F6E\u5B8C\u6574\u6570\u636E");
    form.setFieldsValue(data);
    console.log(logMessage, data);
    const currentValues = form.getFieldsValue();
    console.log("\u{1F50D} \u5F53\u524D\u8868\u5355\u503C:", currentValues);
  };
  const handleFillFullTimeEmployed = () => {
    const data = financialMockDataPresets.fullTimeEmployedTech();
    fillFormData(data, "\u2705 \u5DF2\u586B\u5145\u5168\u804C\u6280\u672F\u5DE5\u4F5C\u8005:");
  };
  const handleFillSelfEmployed = () => {
    const data = financialMockDataPresets.selfEmployed();
    fillFormData(data, "\u2705 \u5DF2\u586B\u5145\u81EA\u96C7\u5546\u4E1A\u4EBA\u58EB:");
  };
  const handleFillHighNetWorth = () => {
    const data = financialMockDataPresets.highNetWorth();
    fillFormData(data, "\u2705 \u5DF2\u586B\u5145\u9AD8\u51C0\u503C\u6295\u8D44\u8005:");
  };
  const handleFillStudent = () => {
    const data = financialMockDataPresets.student();
    fillFormData(data, "\u2705 \u5DF2\u586B\u5145\u5B66\u751F:");
  };
  const handleFillRetired = () => {
    const data = financialMockDataPresets.retired();
    fillFormData(data, "\u2705 \u5DF2\u586B\u5145\u9000\u4F11\u4EBA\u58EB:");
  };
  const handleFillRandom = () => {
    const data = generateFinancialInfoMockData();
    fillFormData(data, "\u2705 \u5DF2\u586B\u5145\u968F\u673A\u8D22\u52A1\u6570\u636E:");
  };
  const handleClear = () => {
    form.resetFields();
    console.log("\u2705 \u5DF2\u6E05\u7A7A\u8D22\u52A1\u4FE1\u606F\u8868\u5355");
  };
  const handleToggle = () => {
    setVisible(!visible);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(import_jsx_runtime3.Fragment, { children: [
    !visible && /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] group cursor-pointer",
        onClick: handleToggle,
        style: {
          width: "64px",
          height: "64px"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full transition-all duration-300 group-hover:scale-110",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 10px 25px -5px rgba(102, 126, 234, 0.5), 0 8px 10px -6px rgba(102, 126, 234, 0.3)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300",
              style: {
                background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                boxShadow: "0 15px 35px -5px rgba(118, 75, 162, 0.6)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { className: "relative w-full h-full flex items-center justify-center text-3xl transition-transform duration-300 group-hover:scale-110 group-active:scale-95", children: "\u{1F4BC}" }),
          /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full animate-ping opacity-20",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                animationDuration: "3s"
              }
            }
          )
        ]
      }
    ),
    visible && /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] bg-white rounded-lg shadow-2xl",
        style: {
          width: "320px",
          maxHeight: "600px",
          display: "flex",
          flexDirection: "column",
          border: "1px solid #d9d9d9"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
            "div",
            {
              className: "flex items-center justify-between px-4 py-3",
              style: {
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
                borderRadius: "8px 8px 0 0"
              },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("span", { className: "font-semibold text-base", children: "\u{1F4BC} \u8D22\u52A1\u4FE1\u606F Mock\u5DE5\u5177" }),
                /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_antd3.Button, { size: "small", onClick: handleToggle, children: "\u2715" })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
            "div",
            {
              className: "overflow-y-auto p-4 space-y-4",
              style: { maxHeight: "500px" },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u9884\u8BBE\u573A\u666F" }),
                  /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_antd3.Button, { size: "small", block: true, onClick: handleFillFullTimeEmployed, children: "\u5168\u804C\u6280\u672F\u5DE5\u4F5C\u8005" }),
                  /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_antd3.Button, { size: "small", block: true, onClick: handleFillSelfEmployed, children: "\u81EA\u96C7\u5546\u4E1A\u4EBA\u58EB" }),
                  /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_antd3.Button, { size: "small", block: true, onClick: handleFillHighNetWorth, children: "\u9AD8\u51C0\u503C\u6295\u8D44\u8005" }),
                  /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_antd3.Button, { size: "small", block: true, onClick: handleFillStudent, children: "\u5B66\u751F" }),
                  /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_antd3.Button, { size: "small", block: true, onClick: handleFillRetired, children: "\u9000\u4F11\u4EBA\u58EB" })
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u5176\u4ED6\u64CD\u4F5C" }),
                  /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_antd3.Button, { size: "small", block: true, onClick: handleFillRandom, children: "\u968F\u673A\u751F\u6210" })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("div", { className: "px-4 pb-4 pt-2 border-t", children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_antd3.Button, { danger: true, size: "small", block: true, onClick: handleClear, children: "\u6E05\u7A7A\u8868\u5355" }) })
        ]
      }
    )
  ] });
}

// src/company/company-info/mockDataGenerator.demo.tsx
var import_antd4 = require("antd");
var import_react4 = require("react");
var import_jsx_runtime4 = require("react/jsx-runtime");
function CompanyMockDataPanel({ form } = {}) {
  const [visible, setVisible] = (0, import_react4.useState)(false);
  const [generatedData, setGeneratedData] = (0, import_react4.useState)(null);
  const handleFillBasic = () => {
    const data = generateCompanyInfoMockData();
    form?.setFieldsValue(data);
    setGeneratedData(data);
    console.log("\u2705 \u5DF2\u586B\u5145\u4F01\u4E1A\u4FE1\u606F\uFF08\u968F\u673A\uFF09:", data);
  };
  const handleFillHKListed = () => {
    const data = companyMockDataPresets.hkListedCompany();
    form?.setFieldsValue(data);
    setGeneratedData(data);
    console.log("\u2705 \u5DF2\u586B\u5145\u4F01\u4E1A\u4FE1\u606F\uFF08\u9999\u6E2F\u4E0A\u5E02\u516C\u53F8\uFF09:", data);
  };
  const handleFillHKPrivate = () => {
    const data = companyMockDataPresets.hkPrivateCompany();
    form?.setFieldsValue(data);
    setGeneratedData(data);
    console.log("\u2705 \u5DF2\u586B\u5145\u4F01\u4E1A\u4FE1\u606F\uFF08\u9999\u6E2F\u975E\u4E0A\u5E02\u516C\u53F8\uFF09:", data);
  };
  const handleFillMainland = () => {
    const data = companyMockDataPresets.mainlandCompany();
    form?.setFieldsValue(data);
    setGeneratedData(data);
    console.log("\u2705 \u5DF2\u586B\u5145\u4F01\u4E1A\u4FE1\u606F\uFF08\u4E2D\u56FD\u5927\u9646\u516C\u53F8\uFF09:", data);
  };
  const handleFillSingapore = () => {
    const data = companyMockDataPresets.singaporeCompany();
    form?.setFieldsValue(data);
    setGeneratedData(data);
    console.log("\u2705 \u5DF2\u586B\u5145\u4F01\u4E1A\u4FE1\u606F\uFF08\u65B0\u52A0\u5761\u516C\u53F8\uFF09:", data);
  };
  const handleFillNonProfit = () => {
    const data = companyMockDataPresets.nonProfitOrg();
    form?.setFieldsValue(data);
    setGeneratedData(data);
    console.log("\u2705 \u5DF2\u586B\u5145\u4F01\u4E1A\u4FE1\u606F\uFF08\u975E\u8425\u5229\u7EC4\u7EC7\uFF09:", data);
  };
  const handleClear = () => {
    form?.resetFields();
    setGeneratedData(null);
    console.log("\u2705 \u5DF2\u6E05\u7A7A\u8868\u5355");
  };
  const handleToggle = () => {
    setVisible(!visible);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(import_jsx_runtime4.Fragment, { children: [
    !visible && /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] group cursor-pointer",
        onClick: handleToggle,
        style: {
          width: "64px",
          height: "64px"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full transition-all duration-300 group-hover:scale-110",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 10px 25px -5px rgba(102, 126, 234, 0.5), 0 8px 10px -6px rgba(102, 126, 234, 0.3)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300",
              style: {
                background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                boxShadow: "0 15px 35px -5px rgba(118, 75, 162, 0.6)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { className: "relative w-full h-full flex items-center justify-center text-3xl transition-transform duration-300 group-hover:scale-110 group-active:scale-95", children: "\u{1F3E2}" }),
          /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full animate-ping opacity-20",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                animationDuration: "3s"
              }
            }
          )
        ]
      }
    ),
    visible && /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] bg-white rounded-lg shadow-2xl",
        style: {
          width: "320px",
          maxHeight: "600px",
          display: "flex",
          flexDirection: "column",
          border: "1px solid #d9d9d9"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(
            "div",
            {
              className: "flex items-center justify-between px-4 py-3",
              style: {
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
                borderRadius: "8px 8px 0 0"
              },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("span", { className: "font-semibold text-base", children: "\u{1F3E2} \u4F01\u4E1AKYC Mock\u5DE5\u5177" }),
                /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_antd4.Button, { size: "small", onClick: handleToggle, children: "\u2715" })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(
            "div",
            {
              className: "overflow-y-auto p-4 space-y-2",
              style: { maxHeight: "500px" },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_antd4.Button, { size: "small", block: true, onClick: handleFillBasic, children: "\u968F\u673A\u4F01\u4E1A\u6570\u636E" }),
                /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_antd4.Button, { size: "small", block: true, onClick: handleFillHKListed, children: "\u9999\u6E2F\u4E0A\u5E02\u516C\u53F8" }),
                /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_antd4.Button, { size: "small", block: true, onClick: handleFillHKPrivate, children: "\u9999\u6E2F\u975E\u4E0A\u5E02\u516C\u53F8" }),
                /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_antd4.Button, { size: "small", block: true, onClick: handleFillMainland, children: "\u4E2D\u56FD\u5927\u9646\u516C\u53F8" }),
                /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_antd4.Button, { size: "small", block: true, onClick: handleFillSingapore, children: "\u65B0\u52A0\u5761\u516C\u53F8" }),
                /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_antd4.Button, { size: "small", block: true, onClick: handleFillNonProfit, children: "\u975E\u8425\u5229\u7EC4\u7EC7" })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { className: "px-4 pb-4 pt-2 border-t", children: /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_antd4.Button, { danger: true, size: "small", block: true, onClick: handleClear, children: "\u6E05\u7A7A\u8868\u5355" }) }),
          generatedData && /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("div", { className: "px-4 pb-4", children: /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)("details", { className: "text-xs", children: [
            /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("summary", { className: "cursor-pointer text-gray-500 hover:text-gray-700", children: "\u67E5\u770B\u751F\u6210\u7684\u6570\u636E" }),
            /* @__PURE__ */ (0, import_jsx_runtime4.jsx)("pre", { className: "mt-2 p-2 bg-gray-50 rounded text-xs overflow-auto max-h-40", children: JSON.stringify(generatedData, null, 2) })
          ] }) })
        ]
      }
    )
  ] });
}

// src/company/company-structure/mockDataGenerator.demo.tsx
var import_antd5 = require("antd");
var import_react5 = require("react");
var import_jsx_runtime5 = require("react/jsx-runtime");
var RELATED_PERSON_TYPE_OPTIONS2 = [
  {
    label: "\u80A1\u4E1C/\u6700\u7EC8\u5B9E\u76CA\u62E5\u6709\u4EBA",
    value: "SHAREHOLDER_BENEFICIAL_OWNER" /* SHAREHOLDER_BENEFICIAL_OWNER */
  },
  { label: "\u8463\u4E8B", value: "DIRECTOR" /* DIRECTOR */ },
  {
    label: "\u6388\u6743\u7B7E\u7F72\u4EBA",
    value: "AUTHORIZED_SIGNATORY" /* AUTHORIZED_SIGNATORY */
  },
  {
    label: "\u4EE3\u8868\u5BA2\u6237\u884C\u4E8B\u7684\u4EBA",
    value: "CLIENT_REPRESENTATIVE" /* CLIENT_REPRESENTATIVE */
  },
  { label: "\u59D4\u6258\u4EBA", value: "PRINCIPAL" /* PRINCIPAL */ }
];
function CompanyStructureMockDataPanel({
  relatedPersons = [],
  onSetRelatedPersons
}) {
  const [visible, setVisible] = (0, import_react5.useState)(false);
  const [personCount, setPersonCount] = (0, import_react5.useState)(3);
  const [showCustomTypes, setShowCustomTypes] = (0, import_react5.useState)(false);
  const [selectedPersonType, setSelectedPersonType] = (0, import_react5.useState)(
    "INDIVIDUAL" /* INDIVIDUAL */
  );
  const [selectedRelatedPersonTypes, setSelectedRelatedPersonTypes] = (0, import_react5.useState)([]);
  const [selectedCorporateTypes, setSelectedCorporateTypes] = (0, import_react5.useState)(["SHAREHOLDER_BENEFICIAL_OWNER" /* SHAREHOLDER_BENEFICIAL_OWNER */]);
  const handleGenerateBatch = (count) => {
    if (relatedPersons.length + count > 10) {
      import_antd5.message.error("\u6700\u591A\u751F\u621010\u4E2A\u5173\u8054\u4EBA\u58EB");
      return;
    }
    const persons = generateRelatedPersonsBatch(count);
    onSetRelatedPersons?.(persons);
    console.log(`\u2705 \u5DF2\u751F\u6210 ${count} \u4E2A\u5173\u8054\u4EBA\u58EB:`, persons);
  };
  const handleGenerateCustomCount = () => {
    handleGenerateBatch(personCount);
  };
  const handleAddCustomPerson = () => {
    const person = generateRelatedPersonData({
      type: selectedPersonType,
      relatedPersonTypes: selectedPersonType === "INDIVIDUAL" /* INDIVIDUAL */ ? selectedRelatedPersonTypes.length > 0 ? selectedRelatedPersonTypes : void 0 : void 0,
      corporateRelatedPersonTypes: selectedPersonType === "CORPORATE" /* CORPORATE */ ? selectedCorporateTypes.length > 0 ? selectedCorporateTypes : void 0 : void 0,
      isShareholdingBeneficiary: selectedRelatedPersonTypes.includes(
        "SHAREHOLDER_BENEFICIAL_OWNER" /* SHAREHOLDER_BENEFICIAL_OWNER */
      )
    });
    onSetRelatedPersons?.([...relatedPersons, person]);
    console.log("\u2705 \u5DF2\u6DFB\u52A0\u81EA\u5B9A\u4E49\u4EBA\u58EB:", person);
  };
  const handleAddIndividualShareholder = () => {
    if (relatedPersons.length >= 10) {
      import_antd5.message.error("\u6700\u591A\u751F\u621010\u4E2A\u5173\u8054\u4EBA\u58EB");
      return;
    }
    const person = companyStructurePresets.individualShareholder();
    onSetRelatedPersons?.([...relatedPersons, person]);
    console.log("\u2705 \u5DF2\u6DFB\u52A0\u4E2A\u4EBA\u80A1\u4E1C:", person);
  };
  const handleAddIndividualDirector = () => {
    if (relatedPersons.length >= 10) {
      import_antd5.message.error("\u6700\u591A\u751F\u621010\u4E2A\u5173\u8054\u4EBA\u58EB");
      return;
    }
    const person = companyStructurePresets.individualDirector();
    onSetRelatedPersons?.([...relatedPersons, person]);
    console.log("\u2705 \u5DF2\u6DFB\u52A0\u4E2A\u4EBA\u8463\u4E8B:", person);
  };
  const handleAddCorporateShareholder = () => {
    if (relatedPersons.length >= 10) {
      import_antd5.message.error("\u6700\u591A\u751F\u621010\u4E2A\u5173\u8054\u4EBA\u58EB");
      return;
    }
    const person = companyStructurePresets.corporateShareholder();
    onSetRelatedPersons?.([...relatedPersons, person]);
    console.log("\u2705 \u5DF2\u6DFB\u52A0\u6CD5\u4EBA\u80A1\u4E1C:", person);
  };
  const handleFillMixedStructure = () => {
    if (relatedPersons.length >= 10) {
      import_antd5.message.error("\u6700\u591A\u751F\u621010\u4E2A\u5173\u8054\u4EBA\u58EB");
      return;
    }
    const persons = companyStructurePresets.mixedStructure();
    onSetRelatedPersons?.(persons);
    console.log("\u2705 \u5DF2\u586B\u5145\u6DF7\u5408\u7ED3\u6784\uFF082\u4E2A\u4E2A\u4EBA+1\u4E2A\u6CD5\u4EBA\uFF09:", persons);
  };
  const handleFillIndividualOnly = () => {
    if (relatedPersons.length >= 10) {
      import_antd5.message.error("\u6700\u591A\u751F\u621010\u4E2A\u5173\u8054\u4EBA\u58EB");
      return;
    }
    const persons = [
      companyStructurePresets.individualShareholder(),
      companyStructurePresets.individualDirector()
    ];
    onSetRelatedPersons?.(persons);
    console.log("\u2705 \u5DF2\u586B\u5145\u4E2A\u4EBA\u4EBA\u58EB\u7ED3\u6784:", persons);
  };
  const handleFillWithCorporate = () => {
    if (relatedPersons.length >= 10) {
      import_antd5.message.error("\u6700\u591A\u751F\u621010\u4E2A\u5173\u8054\u4EBA\u58EB");
      return;
    }
    const persons = [
      companyStructurePresets.individualShareholder(),
      companyStructurePresets.corporateShareholder()
    ];
    onSetRelatedPersons?.(persons);
    console.log("\u2705 \u5DF2\u586B\u5145\u4E2A\u4EBA+\u6CD5\u4EBA\u7ED3\u6784:", persons);
  };
  const handleClear = () => {
    onSetRelatedPersons?.([
      {
        id: `person_${Date.now()}`,
        type: "INDIVIDUAL" /* INDIVIDUAL */,
        isShareholdingBeneficiary: false,
        data: {}
      }
    ]);
    console.log("\u2705 \u5DF2\u6E05\u7A7A\u5173\u8054\u4EBA\u58EB\u5217\u8868");
  };
  const handleToggle = () => {
    setVisible(!visible);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(import_jsx_runtime5.Fragment, { children: [
    !visible && /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] group cursor-pointer",
        onClick: handleToggle,
        style: {
          width: "64px",
          height: "64px"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full transition-all duration-300 group-hover:scale-110",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 10px 25px -5px rgba(102, 126, 234, 0.5), 0 8px 10px -6px rgba(102, 126, 234, 0.3)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300",
              style: {
                background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                boxShadow: "0 15px 35px -5px rgba(118, 75, 162, 0.6)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: "relative w-full h-full flex items-center justify-center text-3xl transition-transform duration-300 group-hover:scale-110 group-active:scale-95", children: "\u{1F465}" }),
          /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full animate-ping opacity-20",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                animationDuration: "3s"
              }
            }
          )
        ]
      }
    ),
    visible && /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] bg-white rounded-lg shadow-2xl",
        style: {
          width: "360px",
          maxHeight: "600px",
          display: "flex",
          flexDirection: "column",
          border: "1px solid #d9d9d9"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
            "div",
            {
              className: "flex items-center justify-between px-4 py-3",
              style: {
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
                borderRadius: "8px 8px 0 0"
              },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { className: "font-semibold text-base", children: "\u{1F465} \u516C\u53F8\u7ED3\u6784 Mock\u5DE5\u5177" }),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_antd5.Button, { size: "small", onClick: handleToggle, children: "\u2715" })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
            "div",
            {
              className: "overflow-y-auto p-4 space-y-4",
              style: { maxHeight: "500px" },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: "text-sm text-gray-600", children: [
                  "\u5F53\u524D\u5173\u8054\u4EBA\u58EB:",
                  " ",
                  /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { className: "font-semibold", children: relatedPersons.length }),
                  " \u4EBA"
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u6279\u91CF\u751F\u6210" }),
                  /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: "flex items-center gap-2", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
                      import_antd5.InputNumber,
                      {
                        min: 1,
                        max: 10,
                        value: personCount,
                        onChange: (value) => setPersonCount(value || 1),
                        style: { width: "80px" },
                        size: "small"
                      }
                    ),
                    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { className: "text-sm text-gray-600", children: "\u4E2A\u4EBA\u58EB" }),
                    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
                      import_antd5.Button,
                      {
                        size: "small",
                        type: "primary",
                        onClick: handleGenerateCustomCount,
                        style: { marginLeft: "auto" },
                        children: "\u751F\u6210"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: "grid grid-cols-3 gap-2", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_antd5.Button, { size: "small", onClick: () => handleGenerateBatch(1), children: "1\u4EBA" }),
                    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_antd5.Button, { size: "small", onClick: () => handleGenerateBatch(3), children: "3\u4EBA" }),
                    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_antd5.Button, { size: "small", onClick: () => handleGenerateBatch(5), children: "5\u4EBA" })
                  ] })
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: "flex items-center justify-between", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u81EA\u5B9A\u4E49\u751F\u6210" }),
                    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
                      import_antd5.Button,
                      {
                        type: "link",
                        size: "small",
                        onClick: () => setShowCustomTypes(!showCustomTypes),
                        style: { padding: 0, height: "auto" },
                        children: showCustomTypes ? "\u6536\u8D77" : "\u5C55\u5F00"
                      }
                    )
                  ] }),
                  showCustomTypes && /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: "space-y-2 bg-gray-50 p-2 rounded", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { children: [
                      /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: "text-xs text-gray-600 mb-1", children: "\u4EBA\u58EB\u7C7B\u578B" }),
                      /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
                        import_antd5.Select,
                        {
                          size: "small",
                          value: selectedPersonType,
                          onChange: setSelectedPersonType,
                          style: { width: "100%" },
                          options: [
                            {
                              label: "\u4E2A\u4EBA",
                              value: "INDIVIDUAL" /* INDIVIDUAL */
                            },
                            {
                              label: "\u6CD5\u4EBA",
                              value: "CORPORATE" /* CORPORATE */
                            }
                          ]
                        }
                      )
                    ] }),
                    selectedPersonType === "INDIVIDUAL" /* INDIVIDUAL */ && /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { children: [
                      /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: "text-xs text-gray-600 mb-1", children: "\u5173\u8054\u4EBA\u58EB\u7C7B\u578B" }),
                      /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
                        import_antd5.Checkbox.Group,
                        {
                          value: selectedRelatedPersonTypes,
                          onChange: (values) => setSelectedRelatedPersonTypes(
                            values
                          ),
                          options: RELATED_PERSON_TYPE_OPTIONS2,
                          style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px"
                          }
                        }
                      )
                    ] }),
                    selectedPersonType === "CORPORATE" /* CORPORATE */ && /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { children: [
                      /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: "text-xs text-gray-600 mb-1", children: "\u6CD5\u4EBA\u5173\u8054\u7C7B\u578B" }),
                      /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
                        import_antd5.Checkbox.Group,
                        {
                          value: selectedCorporateTypes,
                          onChange: (values) => setSelectedCorporateTypes(
                            values
                          ),
                          options: RELATED_PERSON_TYPE_OPTIONS2,
                          style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px"
                          }
                        }
                      )
                    ] }),
                    /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
                      import_antd5.Button,
                      {
                        size: "small",
                        type: "primary",
                        block: true,
                        onClick: handleAddCustomPerson,
                        children: "\u6DFB\u52A0\u81EA\u5B9A\u4E49\u4EBA\u58EB"
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u5FEB\u6377\u6DFB\u52A0" }),
                  /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
                    import_antd5.Button,
                    {
                      size: "small",
                      block: true,
                      onClick: handleAddIndividualShareholder,
                      children: "\u4E2A\u4EBA\u80A1\u4E1C"
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_antd5.Button, { size: "small", block: true, onClick: handleAddIndividualDirector, children: "\u4E2A\u4EBA\u8463\u4E8B" }),
                  /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
                    import_antd5.Button,
                    {
                      size: "small",
                      block: true,
                      onClick: handleAddCorporateShareholder,
                      children: "\u6CD5\u4EBA\u80A1\u4E1C"
                    }
                  )
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u9884\u8BBE\u573A\u666F" }),
                  /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_antd5.Button, { size: "small", block: true, onClick: handleFillMixedStructure, children: "\u6DF7\u5408\u7ED3\u6784\uFF082\u4E2A\u4EBA+1\u6CD5\u4EBA\uFF09" }),
                  /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_antd5.Button, { size: "small", block: true, onClick: handleFillIndividualOnly, children: "\u7EAF\u4E2A\u4EBA\u7ED3\u6784\uFF082\u4EBA\uFF09" }),
                  /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_antd5.Button, { size: "small", block: true, onClick: handleFillWithCorporate, children: "\u4E2A\u4EBA+\u6CD5\u4EBA\uFF08\u54041\uFF09" })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { className: "px-4 pb-4 pt-2 border-t", children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(import_antd5.Button, { danger: true, size: "small", block: true, onClick: handleClear, children: "\u6E05\u7A7A\u5217\u8868" }) })
        ]
      }
    )
  ] });
}

// src/company/company-financial/mockDataGenerator.demo.tsx
var import_antd6 = require("antd");
var import_react6 = require("react");
var import_jsx_runtime6 = require("react/jsx-runtime");
function CompanyFinancialMockDataPanel({
  form
}) {
  const [visible, setVisible] = (0, import_react6.useState)(false);
  if (!form) {
    return null;
  }
  const handleFillSmallProfitable = () => {
    const data = companyFinancialPresets.smallProfitable();
    form.setFieldsValue(data);
    console.log("\u2705 \u5DF2\u586B\u5145\u5C0F\u578B\u76C8\u5229\u4F01\u4E1A\u6570\u636E:", data);
  };
  const handleFillMediumProfitable = () => {
    const data = companyFinancialPresets.mediumProfitable();
    form.setFieldsValue(data);
    console.log("\u2705 \u5DF2\u586B\u5145\u4E2D\u578B\u76C8\u5229\u4F01\u4E1A\u6570\u636E:", data);
  };
  const handleFillLargeProfitable = () => {
    const data = companyFinancialPresets.largeProfitable();
    form.setFieldsValue(data);
    console.log("\u2705 \u5DF2\u586B\u5145\u5927\u578B\u76C8\u5229\u4F01\u4E1A\u6570\u636E:", data);
  };
  const handleFillLossmaking = () => {
    const data = companyFinancialPresets.lossmaking();
    form.setFieldsValue(data);
    console.log("\u2705 \u5DF2\u586B\u5145\u4E8F\u635F\u4F01\u4E1A\u6570\u636E:", data);
  };
  const handleFillHighVaRatio = () => {
    const data = companyFinancialPresets.highVaRatio();
    form.setFieldsValue(data);
    console.log("\u2705 \u5DF2\u586B\u5145\u9AD8\u865A\u62DF\u8D44\u4EA7\u5360\u6BD4\u4F01\u4E1A\u6570\u636E:", data);
  };
  const handleFillLowVaRatio = () => {
    const data = companyFinancialPresets.lowVaRatio();
    form.setFieldsValue(data);
    console.log("\u2705 \u5DF2\u586B\u5145\u4F4E\u865A\u62DF\u8D44\u4EA7\u5360\u6BD4\u4F01\u4E1A\u6570\u636E:", data);
  };
  const handleFillWithOtherSources = () => {
    const data = companyFinancialPresets.withOtherSources();
    form.setFieldsValue(data);
    console.log("\u2705 \u5DF2\u586B\u5145\u5305\u542B\u5176\u4ED6\u6765\u6E90\u7684\u6570\u636E:", data);
  };
  const handleFillRandom = () => {
    const data = generateCompanyFinancialMockData();
    form.setFieldsValue(data);
    console.log("\u2705 \u5DF2\u586B\u5145\u968F\u673A\u8D22\u52A1\u6570\u636E:", data);
  };
  const handleClear = () => {
    form.resetFields();
    console.log("\u2705 \u5DF2\u6E05\u7A7A\u8D22\u52A1\u4FE1\u606F\u8868\u5355");
  };
  const handleToggle = () => {
    setVisible(!visible);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(import_jsx_runtime6.Fragment, { children: [
    !visible && /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] group cursor-pointer",
        onClick: handleToggle,
        style: {
          width: "64px",
          height: "64px"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full transition-all duration-300 group-hover:scale-110",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 10px 25px -5px rgba(102, 126, 234, 0.5), 0 8px 10px -6px rgba(102, 126, 234, 0.3)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300",
              style: {
                background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                boxShadow: "0 15px 35px -5px rgba(118, 75, 162, 0.6)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: "relative w-full h-full flex items-center justify-center text-3xl transition-transform duration-300 group-hover:scale-110 group-active:scale-95", children: "\u{1F4B0}" }),
          /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full animate-ping opacity-20",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                animationDuration: "3s"
              }
            }
          )
        ]
      }
    ),
    visible && /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] bg-white rounded-lg shadow-2xl",
        style: {
          width: "320px",
          maxHeight: "600px",
          display: "flex",
          flexDirection: "column",
          border: "1px solid #d9d9d9"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(
            "div",
            {
              className: "flex items-center justify-between px-4 py-3",
              style: {
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
                borderRadius: "8px 8px 0 0"
              },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("span", { className: "font-semibold text-base", children: "\u{1F4B0} \u8D22\u52A1\u72B6\u51B5 Mock\u5DE5\u5177" }),
                /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_antd6.Button, { size: "small", onClick: handleToggle, children: "\u2715" })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(
            "div",
            {
              className: "overflow-y-auto p-4 space-y-4",
              style: { maxHeight: "500px" },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u9884\u8BBE\u573A\u666F" }),
                  /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_antd6.Button, { size: "small", block: true, onClick: handleFillSmallProfitable, children: "\u5C0F\u578B\u76C8\u5229\u4F01\u4E1A" }),
                  /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_antd6.Button, { size: "small", block: true, onClick: handleFillMediumProfitable, children: "\u4E2D\u578B\u76C8\u5229\u4F01\u4E1A" }),
                  /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_antd6.Button, { size: "small", block: true, onClick: handleFillLargeProfitable, children: "\u5927\u578B\u76C8\u5229\u4F01\u4E1A" }),
                  /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_antd6.Button, { size: "small", block: true, onClick: handleFillLossmaking, children: "\u4E8F\u635F\u4F01\u4E1A" }),
                  /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_antd6.Button, { size: "small", block: true, onClick: handleFillHighVaRatio, children: "\u9AD8\u865A\u62DF\u8D44\u4EA7\u5360\u6BD4" }),
                  /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_antd6.Button, { size: "small", block: true, onClick: handleFillLowVaRatio, children: "\u4F4E\u865A\u62DF\u8D44\u4EA7\u5360\u6BD4" }),
                  /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_antd6.Button, { size: "small", block: true, onClick: handleFillWithOtherSources, children: "\u5305\u542B\u5176\u4ED6\u6765\u6E90" })
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u5176\u4ED6\u64CD\u4F5C" }),
                  /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_antd6.Button, { size: "small", block: true, onClick: handleFillRandom, children: "\u968F\u673A\u751F\u6210" })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: "px-4 pb-4 pt-2 border-t", children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(import_antd6.Button, { danger: true, size: "small", block: true, onClick: handleClear, children: "\u6E05\u7A7A\u8868\u5355" }) })
        ]
      }
    )
  ] });
}

// src/company/company-upload-file/mockDataGenerator.demo.tsx
var import_antd7 = require("antd");
var import_react7 = require("react");
var import_jsx_runtime7 = require("react/jsx-runtime");
function CompanyUploadFileMockDataPanel({
  companyFiles,
  setCompanyFiles,
  corporateFiles,
  setCorporateFiles,
  individualFiles,
  setIndividualFiles,
  signatureFiles,
  setSignatureFiles,
  otherFiles,
  setOtherFiles,
  handleAddFile
}) {
  const [visible, setVisible] = (0, import_react7.useState)(false);
  const [uploading, setUploading] = (0, import_react7.useState)(false);
  const [companyFileCount, setCompanyFileCount] = (0, import_react7.useState)(3);
  const [corporateFileCount, setCorporateFileCount] = (0, import_react7.useState)(2);
  const [individualFileCount, setIndividualFileCount] = (0, import_react7.useState)(2);
  const [signatureFileCount, setSignatureFileCount] = (0, import_react7.useState)(3);
  const [otherFileCount, setOtherFileCount] = (0, import_react7.useState)(0);
  const companyFilesRef = (0, import_react7.useRef)(companyFiles);
  (0, import_react7.useEffect)(() => {
    companyFilesRef.current = companyFiles;
  }, [companyFiles]);
  const handleUploadByCategory = async () => {
    setUploading(true);
    import_antd7.message.loading({
      content: "\u6B63\u5728\u89E6\u53D1\u4E0A\u4F20...",
      key: "upload-category",
      duration: 0
    });
    try {
      console.log("\u{1F504} \u89E6\u53D1\u7B2C\u4E00\u4E2A\u6587\u4EF6\u4E0A\u4F20...");
      await triggerFileUpload({
        fileUrl: "/icon.png",
        fileName: "company-document.png",
        selector: 'input[type="file"]'
      });
      import_antd7.message.loading({
        content: "\u7B49\u5F85\u4E0A\u4F20\u5B8C\u6210...",
        key: "upload-category",
        duration: 0
      });
      let fileId;
      let fileName = "company-document.png";
      const maxAttempts = 20;
      for (let i = 0; i < maxAttempts; i++) {
        await delay(500);
        const latestFiles = companyFilesRef.current;
        const uploadedFile = latestFiles[0];
        if (uploadedFile?.url && uploadedFile.status === "success" /* SUCCESS */) {
          fileId = uploadedFile.url;
          fileName = uploadedFile.fileName || fileName;
          console.log("\u2705 \u4E0A\u4F20\u6210\u529F\uFF0CfileId:", fileId);
          break;
        }
        console.log(`\u23F3 \u7B49\u5F85\u4E0A\u4F20\u5B8C\u6210... (${i + 1}/${maxAttempts})`);
      }
      if (!fileId) {
        throw new Error("\u4E0A\u4F20\u8D85\u65F6\uFF0C\u672A\u83B7\u53D6\u5230fileId");
      }
      import_antd7.message.loading({
        content: "\u6B63\u5728\u8BBE\u7F6E\u6587\u4EF6...",
        key: "upload-category",
        duration: 0
      });
      for (let i = 0; i < otherFileCount; i++) {
        handleAddFile("otherDocuments" /* OTHER */);
        await delay(100);
      }
      const updateFiles = (_files, setter, count) => {
        setter(
          (prev) => prev.map((item, index) => {
            if (index < count) {
              return {
                ...item,
                status: "success" /* SUCCESS */,
                progress: 100,
                url: fileId,
                // 使用真实上传获取的fileId
                fileName
              };
            }
            return item;
          })
        );
      };
      let totalCount = 0;
      if (companyFileCount > 1) {
        setCompanyFiles(
          (prev) => prev.map((item, index) => {
            if (index > 0 && index < companyFileCount) {
              return {
                ...item,
                status: "success" /* SUCCESS */,
                progress: 100,
                url: fileId,
                fileName
              };
            }
            return item;
          })
        );
      }
      totalCount += companyFileCount;
      console.log(`\u2705 \u5DF2\u8BBE\u7F6E ${companyFileCount} \u4E2A\u516C\u53F8\u6587\u4EF6`);
      if (corporateFileCount > 0) {
        updateFiles(corporateFiles, setCorporateFiles, corporateFileCount);
        totalCount += corporateFileCount;
        console.log(`\u2705 \u5DF2\u8BBE\u7F6E ${corporateFileCount} \u4E2A\u6CD5\u4EBA\u80A1\u4E1C\u6587\u4EF6`);
      }
      if (individualFileCount > 0) {
        updateFiles(individualFiles, setIndividualFiles, individualFileCount);
        totalCount += individualFileCount;
        console.log(`\u2705 \u5DF2\u8BBE\u7F6E ${individualFileCount} \u4E2A\u4E2A\u4EBA\u80A1\u4E1C\u6587\u4EF6`);
      }
      if (signatureFileCount > 0) {
        updateFiles(signatureFiles, setSignatureFiles, signatureFileCount);
        totalCount += signatureFileCount;
        console.log(`\u2705 \u5DF2\u8BBE\u7F6E ${signatureFileCount} \u4E2A\u7B7E\u7F72\u6587\u4EF6`);
      }
      if (otherFileCount > 0) {
        await delay(200);
        updateFiles(otherFiles, setOtherFiles, otherFileCount);
        totalCount += otherFileCount;
        console.log(`\u2705 \u5DF2\u8BBE\u7F6E ${otherFileCount} \u4E2A\u5176\u4ED6\u6587\u4EF6`);
      }
      import_antd7.message.success({
        content: `\u2705 \u5DF2\u8BBE\u7F6E ${totalCount} \u4E2A\u6587\u4EF6`,
        key: "upload-category",
        duration: 3
      });
      console.log(`\u2705 \u603B\u5171\u8BBE\u7F6E ${totalCount} \u4E2A\u6587\u4EF6`);
    } catch (error) {
      import_antd7.message.error({
        content: "\u274C \u8BBE\u7F6E\u6587\u4EF6\u5931\u8D25",
        key: "upload-category",
        duration: 3
      });
      console.error("\u274C \u8BBE\u7F6E\u6587\u4EF6\u5931\u8D25:", error);
    } finally {
      setUploading(false);
    }
  };
  const handleUploadAll = async () => {
    setUploading(true);
    import_antd7.message.loading({
      content: "\u6B63\u5728\u89E6\u53D1\u4E0A\u4F20...",
      key: "upload-all",
      duration: 0
    });
    try {
      console.log("\u{1F504} \u89E6\u53D1\u7B2C\u4E00\u4E2A\u6587\u4EF6\u4E0A\u4F20...");
      await triggerFileUpload({
        fileUrl: "/icon.png",
        fileName: "company-document.png",
        selector: 'input[type="file"]'
      });
      import_antd7.message.loading({
        content: "\u7B49\u5F85\u4E0A\u4F20\u5B8C\u6210...",
        key: "upload-all",
        duration: 0
      });
      let fileId;
      let fileName = "company-document.png";
      const maxAttempts = 20;
      for (let i = 0; i < maxAttempts; i++) {
        await delay(500);
        const latestFiles = companyFilesRef.current;
        const uploadedFile = latestFiles[0];
        if (uploadedFile?.url && uploadedFile.status === "success" /* SUCCESS */) {
          fileId = uploadedFile.url;
          fileName = uploadedFile.fileName || fileName;
          console.log("\u2705 \u4E0A\u4F20\u6210\u529F\uFF0CfileId:", fileId);
          break;
        }
        console.log(`\u23F3 \u7B49\u5F85\u4E0A\u4F20\u5B8C\u6210... (${i + 1}/${maxAttempts})`);
      }
      if (!fileId) {
        throw new Error("\u4E0A\u4F20\u8D85\u65F6\uFF0C\u672A\u83B7\u53D6\u5230fileId");
      }
      import_antd7.message.loading({
        content: "\u6B63\u5728\u8BBE\u7F6E\u6240\u6709\u6587\u4EF6...",
        key: "upload-all",
        duration: 0
      });
      const setAll = (setter) => {
        setter(
          (prev) => prev.map((item) => ({
            ...item,
            status: "success" /* SUCCESS */,
            progress: 100,
            url: fileId,
            // 使用真实上传获取的fileId
            fileName
          }))
        );
      };
      setAll(setCompanyFiles);
      setAll(setCorporateFiles);
      setAll(setIndividualFiles);
      setAll(setSignatureFiles);
      setAll(setOtherFiles);
      const totalCount = companyFiles.length + corporateFiles.length + individualFiles.length + signatureFiles.length + otherFiles.length;
      import_antd7.message.success({
        content: `\u2705 \u5DF2\u8BBE\u7F6E ${totalCount} \u4E2A\u6587\u4EF6`,
        key: "upload-all",
        duration: 3
      });
      console.log(`\u2705 \u5DF2\u8BBE\u7F6E ${totalCount} \u4E2A\u6587\u4EF6`);
    } catch (error) {
      import_antd7.message.error({
        content: "\u274C \u8BBE\u7F6E\u6587\u4EF6\u5931\u8D25",
        key: "upload-all",
        duration: 3
      });
      console.error("\u274C \u8BBE\u7F6E\u6587\u4EF6\u5931\u8D25:", error);
    } finally {
      setUploading(false);
    }
  };
  const handleClearAll = () => {
    window.location.reload();
  };
  const handleToggle = () => {
    setVisible(!visible);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)(import_jsx_runtime7.Fragment, { children: [
    !visible && /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] group cursor-pointer",
        onClick: handleToggle,
        style: {
          width: "64px",
          height: "64px"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full transition-all duration-300 group-hover:scale-110",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 10px 25px -5px rgba(102, 126, 234, 0.5), 0 8px 10px -6px rgba(102, 126, 234, 0.3)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300",
              style: {
                background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                boxShadow: "0 15px 35px -5px rgba(118, 75, 162, 0.6)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("div", { className: "relative w-full h-full flex items-center justify-center text-3xl transition-transform duration-300 group-hover:scale-110 group-active:scale-95", children: "\u{1F4CE}" }),
          /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full animate-ping opacity-20",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                animationDuration: "3s"
              }
            }
          )
        ]
      }
    ),
    visible && /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] bg-white rounded-lg shadow-2xl",
        style: {
          width: "320px",
          maxHeight: "600px",
          display: "flex",
          flexDirection: "column",
          border: "1px solid #d9d9d9"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)(
            "div",
            {
              className: "flex items-center justify-between px-4 py-3",
              style: {
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
                borderRadius: "8px 8px 0 0"
              },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("span", { className: "font-semibold text-base", children: "\u{1F4CE} \u8BC1\u660E\u6587\u4EF6 Mock\u5DE5\u5177" }),
                /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(import_antd7.Button, { size: "small", onClick: handleToggle, children: "\u2715" })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)(
            "div",
            {
              className: "overflow-y-auto p-4 space-y-4",
              style: { maxHeight: "500px" },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u{1F522} \u6587\u4EF6\u6570\u91CF\u914D\u7F6E" }),
                  /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("div", { className: "flex items-center justify-between", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("span", { className: "text-xs text-gray-600", children: "\u516C\u53F8\u6587\u4EF6" }),
                    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
                      import_antd7.InputNumber,
                      {
                        size: "small",
                        min: 0,
                        max: 12,
                        value: companyFileCount,
                        onChange: (val) => setCompanyFileCount(val || 0),
                        style: { width: "70px" }
                      }
                    )
                  ] }),
                  /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("div", { className: "flex items-center justify-between", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("span", { className: "text-xs text-gray-600", children: "\u6CD5\u4EBA\u80A1\u4E1C\u6587\u4EF6" }),
                    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
                      import_antd7.InputNumber,
                      {
                        size: "small",
                        min: 0,
                        max: 5,
                        value: corporateFileCount,
                        onChange: (val) => setCorporateFileCount(val || 0),
                        style: { width: "70px" }
                      }
                    )
                  ] }),
                  /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("div", { className: "flex items-center justify-between", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("span", { className: "text-xs text-gray-600", children: "\u4E2A\u4EBA\u80A1\u4E1C\u6587\u4EF6" }),
                    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
                      import_antd7.InputNumber,
                      {
                        size: "small",
                        min: 0,
                        max: 2,
                        value: individualFileCount,
                        onChange: (val) => setIndividualFileCount(val || 0),
                        style: { width: "70px" }
                      }
                    )
                  ] }),
                  /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("div", { className: "flex items-center justify-between", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("span", { className: "text-xs text-gray-600", children: "\u7B7E\u7F72\u6587\u4EF6" }),
                    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
                      import_antd7.InputNumber,
                      {
                        size: "small",
                        min: 0,
                        max: 8,
                        value: signatureFileCount,
                        onChange: (val) => setSignatureFileCount(val || 0),
                        style: { width: "70px" }
                      }
                    )
                  ] }),
                  /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("div", { className: "flex items-center justify-between", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("span", { className: "text-xs text-gray-600", children: "\u5176\u4ED6\u6587\u4EF6" }),
                    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
                      import_antd7.InputNumber,
                      {
                        size: "small",
                        min: 0,
                        max: 10,
                        value: otherFileCount,
                        onChange: (val) => setOtherFileCount(val || 0),
                        style: { width: "70px" }
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u{1F4E4} \u6587\u4EF6\u4E0A\u4F20" }),
                  /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
                    import_antd7.Button,
                    {
                      size: "small",
                      block: true,
                      type: "primary",
                      onClick: handleUploadByCategory,
                      loading: uploading,
                      children: "\u6309\u914D\u7F6E\u4E0A\u4F20"
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
                    import_antd7.Button,
                    {
                      size: "small",
                      block: true,
                      onClick: handleUploadAll,
                      loading: uploading,
                      children: "\u4E0A\u4F20\u6240\u6709\u6587\u4EF6"
                    }
                  )
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u2139\uFE0F \u4F7F\u7528\u8BF4\u660E" }),
                  /* @__PURE__ */ (0, import_jsx_runtime7.jsxs)("div", { className: "text-xs text-gray-600 space-y-1", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("div", { children: "\u2022 \u5728\u4E0A\u65B9\u8BBE\u7F6E\u6BCF\u4E2A\u5206\u7C7B\u9700\u8981\u4E0A\u4F20\u51E0\u4E2A\u6587\u4EF6" }),
                    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("div", { children: '\u2022 \u70B9\u51FB"\u6309\u914D\u7F6E\u4E0A\u4F20"\u6309\u4F60\u7684\u914D\u7F6E\u4E0A\u4F20' }),
                    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("div", { children: '\u2022 \u70B9\u51FB"\u4E0A\u4F20\u6240\u6709\u6587\u4EF6"\u4E0A\u4F20\u5168\u90E827\u4E2A' }),
                    /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("div", { children: "\u2022 \u6BCF\u4E2A\u6587\u4EF6\u90FD\u4F1A\u4E0A\u4F20\u540C\u4E00\u5F20\u56FE\u7247\uFF08/icon.png\uFF09" })
                  ] })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime7.jsx)("div", { className: "px-4 pb-4 pt-2 border-t", children: /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(import_antd7.Button, { danger: true, size: "small", block: true, onClick: handleClearAll, children: "\u6E05\u7A7A\u6240\u6709\u6587\u4EF6\uFF08\u5237\u65B0\u9875\u9762\uFF09" }) })
        ]
      }
    )
  ] });
}

// src/risk-assessment/mockDataGenerator.demo.tsx
var import_antd8 = require("antd");
var import_react8 = require("react");
var import_jsx_runtime8 = require("react/jsx-runtime");
function RiskAssessmentMockDataPanel({
  form,
  quizData
}) {
  const [visible, setVisible] = (0, import_react8.useState)(false);
  const [currentRiskType, setCurrentRiskType] = (0, import_react8.useState)(
    null
  );
  if (!quizData) {
    return null;
  }
  const fillFormData = (riskType) => {
    const mockData = generateRiskAssessmentMockData(quizData, {
      targetRiskType: riskType
    });
    form.setFieldsValue(mockData);
    const agreement = form.getFieldValue("agreement");
    if (!agreement) {
      console.log("\u{1F527} \u6A21\u62DF\u70B9\u51FB\u534F\u8BAE\u786E\u8BA4");
      document.querySelector("label.ant-checkbox-wrapper")?.click();
    } else {
      console.log("\u{1F527} \u534F\u8BAE\u786E\u8BA4\u5DF2\u52FE\u9009");
    }
    setCurrentRiskType(riskType);
    console.log("\u2705 \u5DF2\u586B\u5145\u98CE\u9669\u6D4B\u8BC4\u6570\u636E");
    console.log("\u{1F4CA} \u76EE\u6807\u7C7B\u578B:", riskType);
    console.log("\u{1F4DD} \u8868\u5355\u6570\u636E:", mockData);
  };
  const handleFillConservative = () => {
    fillFormData(RISK_ASSESSMENT_PRESETS.CONSERVATIVE.riskType);
  };
  const handleFillCautious = () => {
    fillFormData(RISK_ASSESSMENT_PRESETS.CAUTIOUS.riskType);
  };
  const handleFillModerate = () => {
    fillFormData(RISK_ASSESSMENT_PRESETS.MODERATE.riskType);
  };
  const handleFillAggressive = () => {
    fillFormData(RISK_ASSESSMENT_PRESETS.AGGRESSIVE.riskType);
  };
  const handleFillVeryAggressive = () => {
    fillFormData(RISK_ASSESSMENT_PRESETS.VERY_AGGRESSIVE.riskType);
  };
  const handleFillRandom = () => {
    const randomRiskType = generateRandomRiskType();
    fillFormData(randomRiskType);
  };
  const handleClear = () => {
    form.resetFields();
    setCurrentRiskType(null);
    console.log("\u{1F5D1}\uFE0F \u5DF2\u6E05\u7A7A\u8868\u5355");
  };
  const handleToggle = () => {
    setVisible(!visible);
  };
  const riskTypeNames = {
    ["IRA_RISK_CONSERVATIVE" /* IRA_RISK_CONSERVATIVE */]: "\u4FDD\u5B88\u578B",
    ["IRA_RISK_CAUTIOUS" /* IRA_RISK_CAUTIOUS */]: "\u8C28\u614E\u578B",
    ["IRA_RISK_MODERATE" /* IRA_RISK_MODERATE */]: "\u7A33\u5065\u578B",
    ["IRA_RISK_AGGRESSIVE" /* IRA_RISK_AGGRESSIVE */]: "\u79EF\u6781\u578B",
    ["IRA_RISK_VERY_AGGRESSIVE" /* IRA_RISK_VERY_AGGRESSIVE */]: "\u6FC0\u8FDB\u578B"
  };
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(import_jsx_runtime8.Fragment, { children: [
    !visible && /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] group cursor-pointer",
        onClick: handleToggle,
        style: {
          width: "64px",
          height: "64px"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full transition-all duration-300 group-hover:scale-110",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 10px 25px -5px rgba(102, 126, 234, 0.5), 0 8px 10px -6px rgba(102, 126, 234, 0.3)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300",
              style: {
                background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                boxShadow: "0 15px 35px -5px rgba(118, 75, 162, 0.6)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: "relative w-full h-full flex items-center justify-center text-3xl transition-transform duration-300 group-hover:scale-110 group-active:scale-95", children: "\u{1F4CA}" }),
          /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full animate-ping opacity-20",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                animationDuration: "3s"
              }
            }
          )
        ]
      }
    ),
    visible && /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] bg-white rounded-lg shadow-2xl",
        style: {
          width: "360px",
          maxHeight: "700px",
          display: "flex",
          flexDirection: "column",
          border: "1px solid #d9d9d9"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
            "div",
            {
              className: "flex items-center justify-between px-4 py-3",
              style: {
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
                borderRadius: "8px 8px 0 0"
              },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("span", { className: "font-semibold text-base", children: "\u{1F4CA} \u98CE\u9669\u6D4B\u8BC4 Mock\u5DE5\u5177" }),
                /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(import_antd8.Button, { size: "small", onClick: handleToggle, children: "\u2715" })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
            "div",
            {
              className: "overflow-y-auto p-4 space-y-4",
              style: { maxHeight: "600px" },
              children: [
                currentRiskType && /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: "bg-blue-50 border border-blue-200 rounded p-3", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: "text-sm font-semibold text-blue-800", children: "\u5F53\u524D\u7C7B\u578B" }),
                  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: "text-2xl font-bold text-blue-600 mt-1", children: riskTypeNames[currentRiskType] }),
                  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: "text-xs text-blue-600 mt-1", children: RISK_ASSESSMENT_PRESETS[Object.keys(RISK_ASSESSMENT_PRESETS).find(
                    (key) => RISK_ASSESSMENT_PRESETS[key].riskType === currentRiskType
                  )]?.description || "" })
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u{1F3AF} \u9884\u8BBE\u573A\u666F" }),
                  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(import_antd8.Button, { size: "small", block: true, onClick: handleFillConservative, children: RISK_ASSESSMENT_PRESETS.CONSERVATIVE.name }),
                  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(import_antd8.Button, { size: "small", block: true, onClick: handleFillCautious, children: RISK_ASSESSMENT_PRESETS.CAUTIOUS.name }),
                  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(import_antd8.Button, { size: "small", block: true, onClick: handleFillModerate, children: RISK_ASSESSMENT_PRESETS.MODERATE.name }),
                  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(import_antd8.Button, { size: "small", block: true, onClick: handleFillAggressive, children: RISK_ASSESSMENT_PRESETS.AGGRESSIVE.name }),
                  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(import_antd8.Button, { size: "small", block: true, onClick: handleFillVeryAggressive, children: RISK_ASSESSMENT_PRESETS.VERY_AGGRESSIVE.name })
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u{1F527} \u5176\u4ED6\u64CD\u4F5C" }),
                  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(import_antd8.Button, { size: "small", block: true, onClick: handleFillRandom, children: "\u968F\u673A\u751F\u6210" }),
                  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(import_antd8.Button, { size: "small", block: true, danger: true, onClick: handleClear, children: "\u6E05\u7A7A\u8868\u5355" })
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u2139\uFE0F \u4F7F\u7528\u8BF4\u660E" }),
                  /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: "text-xs text-gray-600 space-y-1", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { children: "\u2022 \u9009\u62E9\u9884\u8BBE\u573A\u666F\u5FEB\u901F\u586B\u5145\u95EE\u5377" }),
                    /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { children: "\u2022 \u6839\u636E\u98CE\u9669\u7C7B\u578B\u81EA\u52A8\u9009\u62E9\u7B54\u6848" }),
                    /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { children: [
                      "\u2022 \u5171",
                      quizData.questions.length,
                      "\u9053\u9898"
                    ] }),
                    /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { children: "\u2022 \u98CE\u9669\u7C7B\u578B\u4ECE\u4FDD\u5B88\u5230\u6FC0\u8FDB" }),
                    /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)("div", { className: "mt-2 pt-2 border-t border-gray-200", children: [
                      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { className: "font-semibold mb-1", children: "5\u79CD\u98CE\u9669\u7C7B\u578B\uFF1A" }),
                      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { children: "\u4FDD\u5B88\u578B - \u98CE\u9669\u627F\u53D7\u80FD\u529B\u6700\u4F4E" }),
                      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { children: "\u8C28\u614E\u578B - \u98CE\u9669\u627F\u53D7\u80FD\u529B\u8F83\u4F4E" }),
                      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { children: "\u7A33\u5065\u578B - \u98CE\u9669\u627F\u53D7\u80FD\u529B\u4E2D\u7B49" }),
                      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { children: "\u79EF\u6781\u578B - \u98CE\u9669\u627F\u53D7\u80FD\u529B\u8F83\u9AD8" }),
                      /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("div", { children: "\u6FC0\u8FDB\u578B - \u98CE\u9669\u627F\u53D7\u80FD\u529B\u6700\u9AD8" })
                    ] })
                  ] })
                ] })
              ]
            }
          )
        ]
      }
    )
  ] });
}

// src/virtual-asset-test/mockDataGenerator.demo.tsx
var import_antd9 = require("antd");
var import_react9 = require("react");
var import_jsx_runtime9 = require("react/jsx-runtime");
function VirtualAssetMockDataPanel({
  form,
  questions
}) {
  const [visible, setVisible] = (0, import_react9.useState)(false);
  const [targetScore, setTargetScore] = (0, import_react9.useState)(70);
  const [currentScore, setCurrentScore] = (0, import_react9.useState)(0);
  if (!questions || questions.length === 0) {
    return null;
  }
  const fillFormData = (score) => {
    const mockData = generateVirtualAssetMockData(questions, {
      targetScore: score
    });
    form.setFieldsValue(mockData);
    const actualScore = calculateVirtualAssetScore(questions, mockData);
    setCurrentScore(actualScore);
    console.log("\u2705 \u5DF2\u586B\u5145\u865A\u62DF\u8D44\u4EA7\u6D4B\u8BD5\u6570\u636E");
    console.log("\u{1F4CA} \u76EE\u6807\u5206\u6570:", score);
    console.log("\u{1F4CA} \u5B9E\u9645\u5206\u6570:", actualScore);
    console.log("\u{1F4DD} \u8868\u5355\u6570\u636E:", mockData);
  };
  const handleFillFailLow = () => {
    fillFormData(VIRTUAL_ASSET_PRESETS.FAIL_LOW.targetScore);
  };
  const handleFillFailHigh = () => {
    fillFormData(VIRTUAL_ASSET_PRESETS.FAIL_HIGH.targetScore);
  };
  const handleFillPass = () => {
    fillFormData(VIRTUAL_ASSET_PRESETS.PASS.targetScore);
  };
  const handleFillGood = () => {
    fillFormData(VIRTUAL_ASSET_PRESETS.GOOD.targetScore);
  };
  const handleFillExcellent = () => {
    fillFormData(VIRTUAL_ASSET_PRESETS.EXCELLENT.targetScore);
  };
  const handleFillCustom = () => {
    fillFormData(targetScore);
  };
  const handleFillRandom = () => {
    const randomScore = generateRandomScore();
    setTargetScore(randomScore);
    fillFormData(randomScore);
  };
  const handleClear = () => {
    form.resetFields();
    setCurrentScore(0);
    console.log("\u{1F5D1}\uFE0F \u5DF2\u6E05\u7A7A\u8868\u5355");
  };
  const handleToggle = () => {
    setVisible(!visible);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(import_jsx_runtime9.Fragment, { children: [
    !visible && /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] group cursor-pointer",
        onClick: handleToggle,
        style: {
          width: "64px",
          height: "64px"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full transition-all duration-300 group-hover:scale-110",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 10px 25px -5px rgba(102, 126, 234, 0.5), 0 8px 10px -6px rgba(102, 126, 234, 0.3)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300",
              style: {
                background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                boxShadow: "0 15px 35px -5px rgba(118, 75, 162, 0.6)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: "relative w-full h-full flex items-center justify-center text-3xl transition-transform duration-300 group-hover:scale-110 group-active:scale-95", children: "\u{1F4DA}" }),
          /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full animate-ping opacity-20",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                animationDuration: "3s"
              }
            }
          )
        ]
      }
    ),
    visible && /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] bg-white rounded-lg shadow-2xl",
        style: {
          width: "360px",
          maxHeight: "700px",
          display: "flex",
          flexDirection: "column",
          border: "1px solid #d9d9d9"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(
            "div",
            {
              className: "flex items-center justify-between px-4 py-3",
              style: {
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
                borderRadius: "8px 8px 0 0"
              },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { className: "font-semibold text-base", children: "\u{1F4DA} \u865A\u62DF\u8D44\u4EA7\u6D4B\u8BD5 Mock\u5DE5\u5177" }),
                /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(import_antd9.Button, { size: "small", onClick: handleToggle, children: "\u2715" })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(
            "div",
            {
              className: "overflow-y-auto p-4 space-y-4",
              style: { maxHeight: "600px" },
              children: [
                currentScore > 0 && /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(
                  "div",
                  {
                    className: `border rounded p-3 ${currentScore >= 70 ? "bg-green-50 border-green-200" : "bg-red-50 border-red-200"}`,
                    children: [
                      /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
                        "div",
                        {
                          className: `text-sm font-semibold ${currentScore >= 70 ? "text-green-800" : "text-red-800"}`,
                          children: "\u5F53\u524D\u5206\u6570"
                        }
                      ),
                      /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)(
                        "div",
                        {
                          className: `text-2xl font-bold mt-1 ${currentScore >= 70 ? "text-green-600" : "text-red-600"}`,
                          children: [
                            currentScore,
                            " \u5206"
                          ]
                        }
                      ),
                      /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
                        "div",
                        {
                          className: `text-xs mt-1 ${currentScore >= 70 ? "text-green-600" : "text-red-600"}`,
                          children: currentScore >= 70 ? "\u2705 \u901A\u8FC7\uFF08\u226570\u5206\uFF09" : "\u274C \u672A\u901A\u8FC7\uFF08<70\u5206\uFF09"
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u{1F3AF} \u9884\u8BBE\u573A\u666F" }),
                  /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
                    import_antd9.Button,
                    {
                      size: "small",
                      block: true,
                      onClick: handleFillFailLow,
                      className: "text-left",
                      children: /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: "flex justify-between items-center w-full", children: [
                        /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { children: VIRTUAL_ASSET_PRESETS.FAIL_LOW.name }),
                        /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { className: "text-xs text-red-500", children: "\u672A\u901A\u8FC7" })
                      ] })
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
                    import_antd9.Button,
                    {
                      size: "small",
                      block: true,
                      onClick: handleFillFailHigh,
                      className: "text-left",
                      children: /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: "flex justify-between items-center w-full", children: [
                        /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { children: VIRTUAL_ASSET_PRESETS.FAIL_HIGH.name }),
                        /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { className: "text-xs text-red-500", children: "\u672A\u901A\u8FC7" })
                      ] })
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
                    import_antd9.Button,
                    {
                      size: "small",
                      block: true,
                      onClick: handleFillPass,
                      className: "text-left",
                      children: /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: "flex justify-between items-center w-full", children: [
                        /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { children: VIRTUAL_ASSET_PRESETS.PASS.name }),
                        /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { className: "text-xs text-green-500", children: "\u901A\u8FC7" })
                      ] })
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
                    import_antd9.Button,
                    {
                      size: "small",
                      block: true,
                      onClick: handleFillGood,
                      className: "text-left",
                      children: /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: "flex justify-between items-center w-full", children: [
                        /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { children: VIRTUAL_ASSET_PRESETS.GOOD.name }),
                        /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { className: "text-xs text-green-500", children: "\u901A\u8FC7" })
                      ] })
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
                    import_antd9.Button,
                    {
                      size: "small",
                      block: true,
                      onClick: handleFillExcellent,
                      className: "text-left",
                      children: /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: "flex justify-between items-center w-full", children: [
                        /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { children: VIRTUAL_ASSET_PRESETS.EXCELLENT.name }),
                        /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("span", { className: "text-xs text-green-500", children: "\u901A\u8FC7" })
                      ] })
                    }
                  )
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u{1F3B2} \u81EA\u5B9A\u4E49\u5206\u6570" }),
                  /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: "flex items-center gap-2", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
                      import_antd9.InputNumber,
                      {
                        size: "small",
                        min: 0,
                        max: 100,
                        step: 10,
                        value: targetScore,
                        onChange: (val) => setTargetScore(val || 0),
                        style: { width: "100px" },
                        addonAfter: "\u5206"
                      }
                    ),
                    /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(import_antd9.Button, { size: "small", onClick: handleFillCustom, type: "primary", children: "\u586B\u5145" })
                  ] }),
                  /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: "text-xs text-gray-500", children: "\u53EF\u9009\u8303\u56F4: 0, 10, 20, ..., 100 \u5206\uFF0810\u5206\u4E00\u6863\uFF09" })
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u{1F527} \u5176\u4ED6\u64CD\u4F5C" }),
                  /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(import_antd9.Button, { size: "small", block: true, onClick: handleFillRandom, children: "\u968F\u673A\u751F\u6210" }),
                  /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(import_antd9.Button, { size: "small", block: true, danger: true, onClick: handleClear, children: "\u6E05\u7A7A\u8868\u5355" })
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u2139\uFE0F \u4F7F\u7528\u8BF4\u660E" }),
                  /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: "text-xs text-gray-600 space-y-1", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { children: "\u2022 \u9009\u62E9\u9884\u8BBE\u573A\u666F\u5FEB\u901F\u586B\u5145" }),
                    /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { children: "\u2022 \u8F93\u5165\u81EA\u5B9A\u4E49\u5206\u6570\u7CBE\u786E\u63A7\u5236" }),
                    /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { children: [
                      "\u2022 \u6BCF\u9053\u989810\u5206\uFF0C\u5171",
                      questions.length,
                      "\u9053\u9898"
                    ] }),
                    /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { children: "\u2022 \u603B\u5206\u8303\u56F4\uFF1A0-100\u5206" }),
                    /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { children: "\u2022 \u53CA\u683C\u5206\u6570\uFF1A70\u5206\uFF08\u7B54\u5BF97\u9053\u9898\uFF09" }),
                    /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: "mt-2 pt-2 border-t border-gray-200", children: [
                      /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { className: "font-semibold mb-1", children: "\u8BC4\u5206\u89C4\u5219\uFF1A" }),
                      /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { children: "\u2022 \u7B54\u5BF9\uFF1A+10\u5206" }),
                      /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { children: "\u2022 \u7B54\u9519\uFF1A+0\u5206" }),
                      /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("div", { children: "\u2022 70\u5206\u4EE5\u4E0A\u901A\u8FC7\u6D4B\u8BD5" })
                    ] })
                  ] })
                ] })
              ]
            }
          )
        ]
      }
    )
  ] });
}

// src/enhanced-due-diligence/mockDataGenerator.demo.tsx
var import_antd10 = require("antd");
var import_react10 = require("react");
var import_jsx_runtime10 = require("react/jsx-runtime");
function EnhancedDueDiligenceMockDataPanel({
  form
}) {
  const [visible, setVisible] = (0, import_react10.useState)(false);
  const [uploading, setUploading] = (0, import_react10.useState)(false);
  const [fundSourcesCount, setFundSourcesCount] = (0, import_react10.useState)(3);
  const [wealthSourcesCount, setWealthSourcesCount] = (0, import_react10.useState)(3);
  const [othersCount, setOthersCount] = (0, import_react10.useState)(2);
  if (!form) {
    return null;
  }
  const handleUploadFiles = async () => {
    setUploading(true);
    import_antd10.message.loading({
      content: "\u6B63\u5728\u4E0A\u4F20\u6587\u4EF6...",
      key: "upload-files",
      duration: 0
    });
    try {
      console.log("\u{1F504} \u89E6\u53D1\u6587\u4EF6\u4E0A\u4F20...");
      await triggerFileUpload({
        fileUrl: "/icon.png",
        fileName: "edd-document.png",
        selector: 'input[type="file"]'
      });
      import_antd10.message.loading({
        content: "\u7B49\u5F85\u4E0A\u4F20\u5B8C\u6210...",
        key: "upload-files",
        duration: 0
      });
      let uploadedFile = null;
      const maxAttempts = 20;
      for (let i = 0; i < maxAttempts; i++) {
        await delay(500);
        const currentFiles = form.getFieldValue("fundSources");
        if (currentFiles && currentFiles.length > 0 && currentFiles[0]?.fileId) {
          uploadedFile = currentFiles[0];
          console.log("\u2705 \u4E0A\u4F20\u6210\u529F\uFF0CfileId:", uploadedFile.fileId);
          break;
        }
        console.log(`\u23F3 \u7B49\u5F85\u4E0A\u4F20\u5B8C\u6210... (${i + 1}/${maxAttempts})`);
      }
      if (!uploadedFile || !uploadedFile.fileId) {
        throw new Error("\u4E0A\u4F20\u8D85\u65F6\uFF0C\u672A\u83B7\u53D6\u5230fileId");
      }
      import_antd10.message.loading({
        content: "\u6B63\u5728\u8BBE\u7F6E\u6587\u4EF6...",
        key: "upload-files",
        duration: 0
      });
      form.setFieldsValue({
        fundSources: Array(fundSourcesCount).fill(uploadedFile),
        wealthSources: Array(wealthSourcesCount).fill(uploadedFile),
        others: Array(othersCount).fill(uploadedFile)
      });
      const total = fundSourcesCount + wealthSourcesCount + othersCount;
      import_antd10.message.success({
        content: `\u2705 \u5DF2\u8BBE\u7F6E ${total} \u4E2A\u6587\u4EF6`,
        key: "upload-files",
        duration: 3
      });
      console.log(`\u2705 \u5DF2\u8BBE\u7F6E ${total} \u4E2A\u6587\u4EF6\uFF0CfileId:`, uploadedFile.fileId);
    } catch (error) {
      import_antd10.message.error({
        content: "\u274C \u4E0A\u4F20\u5931\u8D25",
        key: "upload-files",
        duration: 3
      });
      console.error("\u274C \u4E0A\u4F20\u5931\u8D25:", error);
    } finally {
      setUploading(false);
    }
  };
  const handleToggle = () => {
    setVisible(!visible);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)(import_jsx_runtime10.Fragment, { children: [
    !visible && /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] group cursor-pointer",
        onClick: handleToggle,
        style: {
          width: "64px",
          height: "64px"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full transition-all duration-300 group-hover:scale-110",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 10px 25px -5px rgba(102, 126, 234, 0.5), 0 8px 10px -6px rgba(102, 126, 234, 0.3)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300",
              style: {
                background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                boxShadow: "0 15px 35px -5px rgba(118, 75, 162, 0.6)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { className: "relative w-full h-full flex items-center justify-center text-3xl transition-transform duration-300 group-hover:scale-110 group-active:scale-95", children: "\u{1F4CB}" }),
          /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full animate-ping opacity-20",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                animationDuration: "3s"
              }
            }
          )
        ]
      }
    ),
    visible && /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] bg-white rounded-lg shadow-2xl",
        style: {
          width: "320px",
          maxHeight: "600px",
          display: "flex",
          flexDirection: "column",
          border: "1px solid #d9d9d9"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)(
            "div",
            {
              className: "flex items-center justify-between px-4 py-3",
              style: {
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
                borderRadius: "8px 8px 0 0"
              },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("span", { className: "font-semibold text-base", children: "\u{1F4CB} \u52A0\u5F3A\u5C3D\u804C\u8C03\u67E5 Mock\u5DE5\u5177" }),
                /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(import_antd10.Button, { size: "small", onClick: handleToggle, children: "\u2715" })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)(
            "div",
            {
              className: "overflow-y-auto p-4 space-y-4",
              style: { maxHeight: "500px" },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u{1F522} \u6587\u4EF6\u6570\u91CF\u914D\u7F6E" }),
                  /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { className: "flex items-center justify-between", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("span", { className: "text-xs text-gray-600", children: "\u8D44\u91D1\u6765\u6E90\u8BC1\u660E" }),
                    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
                      import_antd10.InputNumber,
                      {
                        size: "small",
                        min: 0,
                        max: 10,
                        value: fundSourcesCount,
                        onChange: (val) => setFundSourcesCount(val || 0),
                        style: { width: "70px" }
                      }
                    )
                  ] }),
                  /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { className: "flex items-center justify-between", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("span", { className: "text-xs text-gray-600", children: "\u8D22\u5BCC\u6765\u6E90\u8BC1\u660E" }),
                    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
                      import_antd10.InputNumber,
                      {
                        size: "small",
                        min: 0,
                        max: 10,
                        value: wealthSourcesCount,
                        onChange: (val) => setWealthSourcesCount(val || 0),
                        style: { width: "70px" }
                      }
                    )
                  ] }),
                  /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { className: "flex items-center justify-between", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("span", { className: "text-xs text-gray-600", children: "\u5176\u4ED6\u6587\u4EF6" }),
                    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
                      import_antd10.InputNumber,
                      {
                        size: "small",
                        min: 0,
                        max: 10,
                        value: othersCount,
                        onChange: (val) => setOthersCount(val || 0),
                        style: { width: "70px" }
                      }
                    )
                  ] })
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u{1F4E4} \u6587\u4EF6\u4E0A\u4F20" }),
                  /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
                    import_antd10.Button,
                    {
                      size: "small",
                      block: true,
                      type: "primary",
                      onClick: handleUploadFiles,
                      loading: uploading,
                      children: "\u4E0A\u4F20\u6587\u4EF6"
                    }
                  )
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u2139\uFE0F \u4F7F\u7528\u8BF4\u660E" }),
                  /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)("div", { className: "text-xs text-gray-600 space-y-1", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { children: "\u2022 \u5728\u4E0A\u65B9\u8BBE\u7F6E\u6BCF\u4E2A\u5B57\u6BB5\u9700\u8981\u51E0\u4E2A\u6587\u4EF6" }),
                    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { children: '\u2022 \u70B9\u51FB"\u4E0A\u4F20\u6587\u4EF6"\u4E00\u6B21\u6027\u8BBE\u7F6E\u6240\u6709\u5B57\u6BB5' }),
                    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { children: "\u2022 \u53EA\u4E0A\u4F20\u4E00\u5F20\u56FE\u7247\uFF0C\u7136\u540E\u590D\u7528\u7ED9\u6240\u6709\u5B57\u6BB5" }),
                    /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { children: "\u2022 \u6240\u6709\u6587\u4EF6\u90FD\u4F7F\u7528\u540C\u4E00\u5F20\u56FE\u7247\uFF08/icon.png\uFF09" })
                  ] })
                ] })
              ]
            }
          )
        ]
      }
    )
  ] });
}

// src/supplementary-materials/mockDataGenerator.demo.tsx
var import_antd11 = require("antd");
var import_react11 = require("react");
var import_jsx_runtime11 = require("react/jsx-runtime");
function SupplementaryMaterialsMockDataPanel({
  form
}) {
  const [visible, setVisible] = (0, import_react11.useState)(false);
  const [uploading, setUploading] = (0, import_react11.useState)(false);
  const [fileCount, setFileCount] = (0, import_react11.useState)(5);
  if (!form) {
    return null;
  }
  const handleUploadFiles = async (count) => {
    setUploading(true);
    import_antd11.message.loading({
      content: "\u6B63\u5728\u4E0A\u4F20\u6587\u4EF6...",
      key: "upload-files",
      duration: 0
    });
    try {
      console.log("\u{1F504} \u89E6\u53D1\u6587\u4EF6\u4E0A\u4F20...");
      await triggerFileUpload({
        fileUrl: "/icon.png",
        fileName: "supplementary-material.png",
        selector: 'input[type="file"]'
      });
      import_antd11.message.loading({
        content: "\u7B49\u5F85\u4E0A\u4F20\u5B8C\u6210...",
        key: "upload-files",
        duration: 0
      });
      let uploadedFile = null;
      const maxAttempts = 20;
      for (let i = 0; i < maxAttempts; i++) {
        await delay(500);
        const currentFiles = form.getFieldValue("supplementaryFiles");
        if (currentFiles && currentFiles.length > 0 && currentFiles[0]?.fileId) {
          uploadedFile = currentFiles[0];
          console.log("\u2705 \u4E0A\u4F20\u6210\u529F\uFF0CfileId:", uploadedFile.fileId);
          break;
        }
        console.log(`\u23F3 \u7B49\u5F85\u4E0A\u4F20\u5B8C\u6210... (${i + 1}/${maxAttempts})`);
      }
      if (!uploadedFile || !uploadedFile.fileId) {
        throw new Error("\u4E0A\u4F20\u8D85\u65F6\uFF0C\u672A\u83B7\u53D6\u5230fileId");
      }
      import_antd11.message.loading({
        content: `\u6B63\u5728\u8BBE\u7F6E ${count} \u4E2A\u6587\u4EF6...`,
        key: "upload-files",
        duration: 0
      });
      const files = Array(count).fill(uploadedFile);
      form.setFieldsValue({
        supplementaryFiles: files
      });
      import_antd11.message.success({
        content: `\u2705 \u5DF2\u8BBE\u7F6E ${count} \u4E2A\u6587\u4EF6`,
        key: "upload-files",
        duration: 3
      });
      console.log(`\u2705 \u5DF2\u8BBE\u7F6E ${count} \u4E2A\u6587\u4EF6\uFF0CfileId:`, uploadedFile.fileId);
    } catch (error) {
      import_antd11.message.error({
        content: "\u274C \u4E0A\u4F20\u5931\u8D25",
        key: "upload-files",
        duration: 3
      });
      console.error("\u274C \u4E0A\u4F20\u5931\u8D25:", error);
    } finally {
      setUploading(false);
    }
  };
  const handleUpload1 = () => handleUploadFiles(1);
  const handleUpload5 = () => handleUploadFiles(5);
  const handleUpload10 = () => handleUploadFiles(10);
  const handleUploadCustom = () => handleUploadFiles(fileCount);
  const handleToggle = () => {
    setVisible(!visible);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(import_jsx_runtime11.Fragment, { children: [
    !visible && /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] group cursor-pointer",
        onClick: handleToggle,
        style: {
          width: "64px",
          height: "64px"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full transition-all duration-300 group-hover:scale-110",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 10px 25px -5px rgba(102, 126, 234, 0.5), 0 8px 10px -6px rgba(102, 126, 234, 0.3)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300",
              style: {
                background: "linear-gradient(135deg, #764ba2 0%, #667eea 100%)",
                boxShadow: "0 15px 35px -5px rgba(118, 75, 162, 0.6)"
              }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: "relative w-full h-full flex items-center justify-center text-3xl transition-transform duration-300 group-hover:scale-110 group-active:scale-95", children: "\u{1F4C4}" }),
          /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
            "div",
            {
              className: "absolute inset-0 rounded-full animate-ping opacity-20",
              style: {
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                animationDuration: "3s"
              }
            }
          )
        ]
      }
    ),
    visible && /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(
      "div",
      {
        className: "fixed bottom-8 right-8 z-[9999] bg-white rounded-lg shadow-2xl",
        style: {
          width: "320px",
          maxHeight: "600px",
          display: "flex",
          flexDirection: "column",
          border: "1px solid #d9d9d9"
        },
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(
            "div",
            {
              className: "flex items-center justify-between px-4 py-3",
              style: {
                borderBottom: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
                borderRadius: "8px 8px 0 0"
              },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("span", { className: "font-semibold text-base", children: "\u{1F4C4} \u8865\u5145\u6750\u6599 Mock\u5DE5\u5177" }),
                /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(import_antd11.Button, { size: "small", onClick: handleToggle, children: "\u2715" })
              ]
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(
            "div",
            {
              className: "overflow-y-auto p-4 space-y-4",
              style: { maxHeight: "500px" },
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u{1F680} \u5FEB\u6377\u4E0A\u4F20" }),
                  /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                    import_antd11.Button,
                    {
                      size: "small",
                      block: true,
                      type: "primary",
                      onClick: handleUpload1,
                      loading: uploading,
                      children: "\u4E0A\u4F20 1 \u4E2A\u6587\u4EF6"
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                    import_antd11.Button,
                    {
                      size: "small",
                      block: true,
                      type: "primary",
                      onClick: handleUpload5,
                      loading: uploading,
                      children: "\u4E0A\u4F20 5 \u4E2A\u6587\u4EF6"
                    }
                  ),
                  /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                    import_antd11.Button,
                    {
                      size: "small",
                      block: true,
                      type: "primary",
                      onClick: handleUpload10,
                      loading: uploading,
                      children: "\u4E0A\u4F20 10 \u4E2A\u6587\u4EF6\uFF08\u6700\u5927\uFF09"
                    }
                  )
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u{1F522} \u81EA\u5B9A\u4E49\u6570\u91CF" }),
                  /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { className: "flex items-center gap-2", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                      import_antd11.InputNumber,
                      {
                        size: "small",
                        min: 1,
                        max: 10,
                        value: fileCount,
                        onChange: (val) => setFileCount(val || 1),
                        style: { width: "100px" },
                        addonAfter: "\u4E2A"
                      }
                    ),
                    /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
                      import_antd11.Button,
                      {
                        size: "small",
                        onClick: handleUploadCustom,
                        loading: uploading,
                        type: "primary",
                        children: "\u4E0A\u4F20"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: "text-xs text-gray-500", children: "\u53EF\u9009\u8303\u56F4: 1 - 10 \u4E2A\u6587\u4EF6" })
                ] }),
                /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: "border-t border-gray-200" }),
                /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { className: "text-sm font-semibold text-gray-700", children: "\u2139\uFE0F \u4F7F\u7528\u8BF4\u660E" }),
                  /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { className: "text-xs text-gray-600 space-y-1", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { children: "\u2022 \u6BCF\u4E2A\u6587\u4EF6\u90FD\u4F1A\u4E0A\u4F20\u540C\u4E00\u5F20\u56FE\u7247\uFF08/icon.png\uFF09" }),
                    /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { children: "\u2022 \u6700\u591A\u53EF\u4E0A\u4F20 10 \u4E2A\u6587\u4EF6" }),
                    /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { children: "\u2022 \u4E0A\u4F20\u5B8C\u6210\u540E\u53EF\u5728\u8868\u5355\u4E2D\u67E5\u770B" }),
                    /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("div", { children: "\u2022 \u652F\u6301\u81EA\u5B9A\u4E49\u4E0A\u4F20\u6570\u91CF" })
                  ] })
                ] })
              ]
            }
          )
        ]
      }
    )
  ] });
}

// src/index.ts
var createCompanyInfo = generateCompanyInfoMockData;
var createCompanyInfoBatch = generateCompanyInfoMockDataBatch;
var companyInfoPresets = companyMockDataPresets;
var createRelatedPerson = generateRelatedPersonData;
var createRelatedPersonBatch = generateRelatedPersonsBatch;
var createCompanyFinancial = generateCompanyFinancialMockData;
var createCompanyFinancialBatch = generateCompanyFinancialMockDataBatch;
var createRiskAssessment = generateRiskAssessmentMockData;
var getRandomRiskType = generateRandomRiskType;
var createVirtualAssetData = generateVirtualAssetMockData;
var getRandomScore = generateRandomScore;
var PersonalKYC = {
  // 个人信息
  personalInfo: {
    create: generatePersonalInfoMockData,
    createBatch: generatePersonalInfoMockDataBatch,
    presets: mockDataPresets
  },
  // 地址信息
  address: {
    create: generateAddressInfoMockData,
    createBatch: generateAddressInfoMockDataBatch,
    presets: addressMockDataPresets
  },
  // 财务信息
  financial: {
    create: generateFinancialInfoMockData,
    createBatch: generateFinancialInfoMockDataBatch,
    presets: financialMockDataPresets
  }
};
var CompanyKYC = {
  // 公司信息
  companyInfo: {
    create: createCompanyInfo,
    createBatch: createCompanyInfoBatch,
    presets: companyInfoPresets
  },
  // 公司结构
  structure: {
    create: createRelatedPerson,
    createBatch: createRelatedPersonBatch,
    presets: companyStructurePresets
  },
  // 公司财务
  financial: {
    create: createCompanyFinancial,
    createBatch: createCompanyFinancialBatch,
    presets: companyFinancialPresets
  }
};
var Assessment = {
  // 风险测评
  risk: {
    create: createRiskAssessment,
    presets: RISK_ASSESSMENT_PRESETS
  },
  // 虚拟资产测试
  virtualAsset: {
    create: createVirtualAssetData,
    calculateScore: calculateVirtualAssetScore,
    presets: VIRTUAL_ASSET_PRESETS
  }
};
var Utils = {
  fileUpload: {
    trigger: triggerFileUpload,
    triggerMultiple: triggerMultipleFileUploads,
    triggerByTestId: triggerFileUploadByTestId,
    triggerAll: triggerAllFileUploads
  }
};
var Panels = {
  // 个人KYC
  PersonalInfo: PersonalInfoMockDataPanel,
  AddressInfo: AddressInfoMockDataPanel,
  FinancialInfo: FinancialInfoMockDataPanel,
  // 企业KYC
  CompanyInfo: CompanyMockDataPanel,
  CompanyStructure: CompanyStructureMockDataPanel,
  CompanyFinancial: CompanyFinancialMockDataPanel,
  CompanyUploadFile: CompanyUploadFileMockDataPanel,
  // 测评问卷
  RiskAssessment: RiskAssessmentMockDataPanel,
  VirtualAsset: VirtualAssetMockDataPanel,
  // 其他
  EnhancedDueDiligence: EnhancedDueDiligenceMockDataPanel,
  SupplementaryMaterials: SupplementaryMaterialsMockDataPanel
};
var src_default = {
  PersonalKYC,
  CompanyKYC,
  Assessment,
  Utils,
  Panels
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  AddressInfoPanel,
  Assessment,
  CompanyFinancialPanel,
  CompanyInfoPanel,
  CompanyKYC,
  CompanyStructurePanel,
  CompanyUploadFilePanel,
  EnhancedDueDiligencePanel,
  FinancialInfoPanel,
  Panels,
  PersonalInfoPanel,
  PersonalKYC,
  RESIDENCE_PROOF_TYPES,
  RISK_ASSESSMENT_PRESETS,
  RiskAssessmentPanel,
  SupplementaryMaterialsPanel,
  Utils,
  VIRTUAL_ASSET_PRESETS,
  VirtualAssetPanel,
  addressInfoPresets,
  calculateVirtualAssetScore,
  companyFinancialPresets,
  companyInfoPresets,
  companyStructurePresets,
  createAddressInfo,
  createAddressInfoBatch,
  createCompanyFinancial,
  createCompanyFinancialBatch,
  createCompanyInfo,
  createCompanyInfoBatch,
  createFinancialInfo,
  createFinancialInfoBatch,
  createPersonalInfo,
  createPersonalInfoBatch,
  createRelatedPerson,
  createRelatedPersonBatch,
  createRiskAssessment,
  createVirtualAssetData,
  financialInfoPresets,
  getRandomRiskType,
  getRandomScore,
  personalInfoPresets,
  triggerAllFileUploads,
  triggerFileUpload,
  triggerFileUploadByTestId,
  triggerMultipleFileUploads
});
